/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */

module.exports = {
  A_CHATTER_GROUP: 'A Chatter Group',
  ABOUT: 'About',
  ACTOR: 'Actor',
  APPLY: 'Apply',
  ACCESS_TOKEN_OWNER_ID_ERROR:
    'Sorry, Spanning is unable to complete this Cross-Org Restore. The destination Salesforce org has been authenticated with another user’s credentials. Please reinitiate the restore from Spanning Dashboard.',
  ACCOUNT: 'Account',
  ACCOUNT_LOGIN_DISABLED: 'Account login disabled',
  ACCOUNT_LOGIN_ENABLED: 'Account login enabled',
  ALERT_NOTIFICATION_DISABLED: 'Alert notification disabled',
  ALERT_NOTIFICATION_ENABLED: 'Alert notification enabled',
  RETENTION_DISABLED: 'Retention disabled',
  RETENTION_ENABLED: 'Retention enabled',
  RETENTION_RULE_CREATED: 'Retention rule created',
  RETENTION_RULE_CHANGED: 'Retention rule changed',
  RETENTION_RULE_DELETED: 'Retention rule deleted',
  ACCOUNT_NAME: 'Account Name',
  ACCOUNT_SETTINGS: 'Settings',
  ACCOUNTS: 'Accounts',
  ACTION: 'Action',
  ACTION_PROGRESS_TTIP: '$0 in progress',
  ACTIVE_ALERTS: 'Active Alerts',
  ACTIVITY: 'Activity',
  ACTIVITY_HISTORY: 'Activity History',
  ACTIVITY_HISTORY_CSV_TOOLTIP: 'Download a csv of activity log',
  ACTIVITY_LOG_EXPORT_NOTE_TITLE: 'No Activities For Selected Filters',
  ACTIVITY_LOG_EXPORT_NOTE_DESCRIPTION:
    'Try changing filters if you want to export based on filtered results only or use entire log export.',
  ACTIVITY_LOG_EXPORT_OPTIONS: 'Export Options',
  ACTIVITY_LOG_EXPORT_OPTIONS_ENTIRE: 'Entire Log',
  ACTIVITY_LOG_EXPORT_OPTIONS_FILTERED: 'Filtered Results Only',
  ACTIVITY_LOG_EXPORT_DESCRIPTION:
    'You can export either the entire Activity Log, or the filtered results only. Please select which option you would like to export.',
  ADD: 'add',
  ADDED: 'Added',
  ADD_ALERT_RULE: 'Add Alert',
  ADD_CARD: 'Add credit card',
  ADD_CARD_REQ: 'add a credit card.',
  ADD_NEW_ORG: 'Add a new org',
  ADD_NEW_SALESFORCE_ORG: 'Add a New Salesforce Org',
  ADD_RECEIPT_INFO: 'ADD RECEIPT INFO',
  ADDITIONAL_INFO: 'Additional Info',
  ADDITIONAL_SUPPORT:
    '<a class="sbsf-link" target="_blank" href="$0"><span>For more information, click here.</span></a>',
  ADD_RECEIPT_INFO_ETC: 'Add Receipt Info (VAT, etc)',
  ADDED_OBJECT_TYPE_EXCLUSION: "Excluded ''{newValue}'' object from backup",
  ADDED_OBJECT_TYPE_FIELD_EXCLUSION: "Excluded ''{newValue}'' object field from backup",
  ADDED_OBJECT_TYPE_EXCLUSION_LABEL: 'Added Object Type Exclusion',
  ADDED_OBJECT_TYPE_FIELD_EXCLUSION_LABEL: 'Added Object Type Field Exclusion',
  ADMINISTRATOR: 'Administrator',
  ADMIN_CREDENTIALS: 'Admin Credentials',
  ALERT_ME_WHEN: 'Alert me when the number of records',
  ALERT_RULE_ADD_TOOLTIP: 'Add a new alert',
  ALERT_RULE_ADDED: 'Rule-based alert added',
  ALERT_RULE_ADDED_FAILURE_MSG: 'The alert could not be added',
  ALERT_RULE_ADDED_SUCCESS_MSG: 'The alert was added',
  ALERT_RULE_CHANGE_TRIGGER_VALUE_TOOLTIP: 'Object count or percent',
  ALERT_RULE_CHANGED: 'The alert was updated',
  ALERT_RULE_COMPLETE_EDIT_BEFORE_ADDING_TOOLTIP: 'Complete the edit in progress before adding a new alert',
  ALERT_RULE_COUNT_TRIGGER_VALUE_TOOLTIP: 'Object count',
  ALERT_RULE_DELETE_MSG: 'Are you sure you want to delete the selected alert?',
  ALERT_RULE_DELETE_TITLE: 'Delete alert',
  ALERT_RULE_DELETE_TOOLTIP: 'Delete this alert',
  ALERT_RULE_DELETED: 'Rule-based alert deleted',
  ALERT_RULE_DELETED_FAILURE_MSG: 'The alert could not be deleted',
  ALERT_RULE_DELETED_SUCCESS_MSG: 'The alert was deleted',
  ALERT_RULE_EDIT_TOOLTIP: 'Edit this alert',
  ALERT_RULE_FINISH_EDIT_TOOLTIP: 'Finish editing this alert',
  ALERT_RULE_LIST_ERROR: 'Could not get the list of alert rules',
  ALERT_RULE_OBJECT_TYPE_LIST_ERROR: 'Could not get the list of object types',
  ALERT_RULE_REVERT_TOOLTIP: 'Discard changes to this alert',
  ALERT_RULE_SAVE_EXISTS_TOOLTIP: 'An alert already exists with this definition',
  ALERT_RULE_SAVE_FIX_TOOLTIP: 'Fix the alert before saving',
  ALERT_RULE_SAVE_NO_CHANGES_TOOLTIP: 'There are no changes to be saved',
  ALERT_RULE_SAVE_TOOLTIP: 'Save this alert',
  ALERT_RULE_SAVED_FAILURE_MSG: 'The alert could not be saved',
  ALERT_RULE_SAVED_SUCCESS_MSG: 'The alert was saved',
  ALERT_RULE_SETTINGS_DESC:
    'The alertSettings will be sent to the email address and Chatter feed configured for notifications.',
  ALERT_RULE_UNSAVED_CHANGES_ALL_MSG: 'OK to discard unsaved changes to the rule-based alertSettings?',
  ALERT_RULE_UNSAVED_CHANGES_ONE_MSG: 'OK to discard unsaved changes to the selected alert?',
  ALERT_RULE_UNSAVED_CHANGES_TITLE: 'Confirm loss of changes',
  ALERTS: 'Alerts',
  ALL_ACTIVITY: 'All Activity',
  ALL_OBJECTS: 'All Objects',
  ALL_SET: "YOU'RE ALL SET!",
  ALL_RECORDS_AND_METADATA: 'all records & metadata',
  ALL_DATETIME_FIELDS_REQUIRED: 'All date and time fields must be filled.',
  ALLOW_COOKIES: "Please allow cookies from 3rd parties in your browser's preferences.",
  ALPHABETICALLY_ASC: 'Alpha - A to Z',
  ALPHABETICALLY_DESC: 'Alpha - Z to A',
  AM: 'AM',
  AMOUNT: 'Amount',
  AND: 'and',
  AND_WERE: 'and were',
  ANOTHER_BACKUP_BATCH: 'Another backup batch',
  API_ACCOUNT_AUTH: 'API Account Authentication',
  API_CALL: '1 API Call',
  API_CALLS: '$0 API Calls',
  API_CHANGE_MSG: 'You&rsquo;ve successfully changed accounts.',
  API_KEY_AND_SECRET: 'External API Key & Secret',
  API_HISTORY_HEADER: 'API Calls',
  API_LIMIT: 'API Limit',
  API_LIMIT_MSG: 'The API Limit is now $0 calls.',
  API_MAX_MSG: 'Set the MAXIMUM number of day API calls that Spanning Backup may use.',
  API_USAGE: 'API Usage',
  API_USAGE_HELP: 'This area will be used to track your API usage.',
  ARE: 'are',
  ARE_SURE_GENERATE_NEW_SECRET: 'Are you sure you want to generate a new API secret key?',
  ARE_SURE_STOP: 'Are you sure you want to stop operation?',
  ARE_SURE_DELETE_SECRET: 'Are you sure you want to delete API secret key?',
  AS_IT_APPEARS_CARD: 'As it appears on your card',
  ASTERISK: '*',
  AT_LEAST_2_BACKUPS: 'You need at least 2 complete backups in order to use this feature.',
  AT_LEAST_1_BACKUP_SEARCH: 'You need at least 1 complete backup in order to use this feature.',
  AT_LEAST_1_BACKUP: 'You need at least 1 complete backup in order to use this compare metadata feature.',
  ATTACHMENTS: 'attachments',
  ATTACHMENTS_MSG:
    'Attachments listed here are not in the current version.  Restoring them will not overwrite existing attachments.',
  AUDIT_HISTORY_CSV_TOOLTIP: 'Download a csv of all settings history',
  AUDIT_VIEW_TYPE_NOT_FOUND: 'Audit view type not found.',
  AUTOMATED_BACKUPS: 'Automated Backups',
  AUTHORIZE: 'Authorize',
  AUTHORIZE_TO_SANDBOX: 'Authorize to Sandbox',
  AUTHORIZE_ORG: 'Authorize production/development org',
  AUTHORIZE_SANDBOX_ORG: 'Authorize sandbox org',
  AUTOMATED_BACKUPS_WILL_START: `Automated backups will start within one hour of the time scheduled. For more information, <a href="$0" target="_blank">click here</a>.`,
  AVERAGE: 'Average',
  AVG: 'Avg',
  BACK: 'Back',
  BACK_UP_NOW: 'back up now',
  BACK_UP_SHORTLY: "We'll be back up shortly.",
  BACKUP: 'Backup',
  BACKUP_AND_SECURITY: 'Backup & Security',
  BACKUP_NOW: 'Backup Now',
  BACKUP_AVERAGE: 'Average ($0)',
  BACKUP_COUNT_CLICK_TO_TOGGLE: 'Click to show/hide the $0 line',
  BACKUP_COUNT_HISTORY: 'backup count history',
  BACKUP_DATA_DELETION_AND_ANONYMIZATION: 'Backup Data Deletion and Anonymization',
  BACKUP_DETAILS: 'Backup Details >',
  BACKUP_DURATION_HISTORY: 'Backup Duration History',
  BACKUP_DURATION_HOURS: 'Duration (hrs)',
  BACKUP_HISTORY: 'Backup History',
  BACKUP_NET_BIND_ORGANIZATION: 'Backup.net organization has been bound',
  BACKUP_NET_UNBIND_ORGANIZATION: 'Backup.net organization has been unbound',
  BACKUP_PICKER_HIDDEN_DATE_TOOLTIP: 'Click to see the list of backups',
  BACKUP_PICKER_VISIBLE_DATE_TOOLTIP: 'Click to hide the list of backups',
  BACKUP_SCHEDULE: 'Backup Schedule',
  BACKUP_SCHEDULE_HELP: `Automated backups will start within one hour of the time scheduled. For more information, {link}.`,
  BACKUP_START_TIME: 'Backup Start Time',
  BACKUP_DATE: 'Backup Date',
  BACKUP_TIMES: 'backup times',
  BACKUP_TRIGGERED: 'The backup triggered $0 alertSettings.',
  BACKUP_TYPE_CUSTOM_TIME_BACKUP: 'automated',
  BACKUP_TYPE_MANUAL_BACKUP: 'Manual',
  BACKUP_TYPE_SCHEDULED_BACKUP: 'Automated',
  BACKUP_WAS_SUCCESSFUL: 'Backup was Successful!',
  BACKUP_WAS_FAILED: 'Backup Failed!',
  BACKUP_WAS_SUCCESSFUL_PARTIAL: 'An Unexpected Problem Occurred!',
  BACKING_UP: 'BACKING UP $0',
  BATCH_CANCELLED: 'The process was stopped',
  BATCH_CANCELLED_DESC: 'During the execution, the process was manually stopped',
  BATCH_DATE: '$0 $1',
  BATCH_LATEST_PREFIX: 'The latest',
  BATCH_OTHER_PREFIX: 'This',
  BATCH_FAILURE_MSG: ' backup stopped due to an error.',
  BATCH_PARTIAL_MSG: ' backup was partially successful.',
  BATCH_SUCCESS_MSG: ' backup was successful.',
  BEFORE_RUNNING_CROSS_ORG_RESTORE: 'Before Running a Cross-Org Restore:',
  BEGIN_SEARCH: 'Press "Run Search" to begin your search',
  BILLED_TO: 'Billed To',
  BILLING: 'Billing',
  BILLING_NOTIFICATION_DESC: 'Choose the email address you want billing related notifications to be delivered to.',
  BILLING_NOTIFICATION_PREFERENCES: 'Billing Notification Preferences',
  BILLING_NOTIFICATION_EMAILS: 'Billing Notification Emails',
  BINARY_CONTENT: 'Content contains binary data and cannot be displayed.',
  BROWSE: 'Browse',
  BULK_API: 'Bulk API',
  BULK_API_MAX_MSG: 'Set the MAXIMUM number of hour Bulk API calls that Spanning Backup may use.',
  BULK_RESTORE: 'Multi-Record Restore',
  BULK_RESTORE_CSV_VERIFICATION: 'CSV Verification',
  BULK_RESTORE_CSV_VERIFICATION_CHECKBOX_TOOLTIP:
    'CSV restore does not support full single object restore. Please, select all data or expand object and select required records to restore.',
  BULK_RESTORE_CSV_VERIFICATION_EXPORT: 'CSV Verification For Export',
  BULK_RESTORE_CSV_VERIFICATION_BULK_RESTORE: 'CSV Verification For Restore',
  BULK_RESTORE_IGNORE_WARNINGS: 'Ignore Warnings',
  BULK_RESTORE_IGNORE_WARNINGS_INFO:
    'Spanning backup will ignore warnings from Salesforce during this metadata restore only.',
  BULK_RESTORE_MORE_INFO_LINK: `<a href="$0" target="_blank">For more information, click here</a>`,
  BULK_RESTORE_PREVIEW: 'Multi-Record Export',
  BULK_RESTORE_PREVIEW_COMPLETED: 'Multi-Record export complete. Click here to view and download',
  BULK_RESTORE_PREVIEW_DISABLED:
    'A multi-record export is currently in progress. Please wait for it to complete before starting another one.',
  BULK_RESTORE_PREVIEW_PROGRESS: 'MULTI-RECORD EXPORT $0',
  BULK_RESTORE_PREVIEW_SUBMIT_FAILED: 'There was a problem submitting the multi-record export. Please try again.',
  BULK_RESTORE_PROGRESS_MSG: '<strong><span class="sbsf-dark-blue">$0</span> $1</strong>',
  BULK_RESTORE_PROGRESS_MSG_TOTAL_ITEMS: ' ($0 total items)',
  BULK_RESTORE_PROGRESS_TOTAL_ITEMS: '({totalObjects} total items)',
  BULK_RESTORE_REFS_BTN: 'View Related Object Types',
  BULK_RESTORE_REFS_BTN_TIP: 'Display reference fields in the objects selected for restore',
  BULK_RESTORE_REFS_INTRO:
    'Below is the list of related object types for the items chosen to restore. Your restore may run into errors if the related records do not exist in the Salesforce org.',
  BULK_RESTORE_REFS_TITLE: 'Related Object Types',
  RUNNING: 'running',
  BULK_RESTORE_RUNNING: 'multi-record restore running',
  BULK_RESTORE_SUBMIT_FAILED: 'There was a problem submitting the restore. Please try again.',
  BY: 'By',
  BY_AT_LEAST: 'by at least',
  CLEAR_FILTERS: 'Clear Filters',
  CANCEL: 'Cancel',
  CANCEL_EDIT_SEARCH_TOOLTIP: 'Stop editing the search criteria and discard any changes',
  CANCELLED: 'Cancelled',
  CANCELLING: 'cancelling',
  CANCELLING_MSG: '$0 Cancelling',
  CANCEL_CONFIRM_MESSAGE: 'You are about to stop this operation. Are you sure you would like to continue?',
  CANCEL_OPERATION: 'Cancel Operation',
  CALL_COUNT: 'call count',
  CALL_COUNT_LABEL: 'Call Count',
  CALLS: 'Calls',
  CARD_NUMBER: 'Card Number',
  CURRENT: 'Current',
  CARD_NUMBER_PLACEHOLDER: '1111 1111 1111 1111',
  CARDHOLDERS_NAME: "cardholder's name",
  CC_CVC_DEFAULT_TOOLTIP: 'Enter the CVC code from the back of your card',
  CC_CVC_INVALID_TOOLTIP: 'Please enter a valid CVC',
  CC_CVC_REQUIRED_TOOLTIP: 'CVC is required',
  CC_MONTH_DEFAULT_TOOLTIP: 'Enter the number of the month your card expires',
  CC_MONTH_INVALID_TOOLTIP: 'Please enter a valid expiration month',
  CC_MONTH_REQUIRED_TOOLTIP: 'Expiration month is required',
  CC_YEAR_DEFAULT_TOOLTIP: 'Enter the last 2 digits of the year your card expires',
  CC_YEAR_INVALID_TOOLTIP: 'Please enter a valid expiration year',
  CC_YEAR_REQUIRED_TOOLTIP: 'Expiration year is required',
  CC_NAME_DEFAULT_TOOLTIP: 'Enter your name as it appears on your card',
  CC_NAME_INVALID_TOOLTIP: 'Please enter a valid name',
  CC_NAME_REQUIRED_TOOLTIP: 'Cardholder name is required',
  CC_NUMBER_DEFAULT_TOOLTIP: 'Enter your card number',
  CC_NUMBER_INVALID_TOOLTIP: 'Please enter a valid card number',
  CC_NUMBER_REQUIRED_TOOLTIP: 'Card number is required',
  CHANGE_API: 'Change API $0',
  CHANGE_API_ACCOUNT: 'Change API Account',
  CHANGE_API_ACCOUNT_TEXT:
    'In order to change the API authentication account, you must be signed into that account. The following account is currently being used to authenticate with the API',
  CHANGE_API_LIMIT: 'Change API Limit',
  CHATTER_DESTINATION: 'select chatter posts destination',
  CHILDREN: 'Children ($0)',
  CHILDREN_NO_PARAMS: 'Children',
  ONE_CHANGE: '1 Change',
  CHANGE_ORG: 'Change production/development org',
  CHANGE_SANDBOX_ORG: 'Change sandbox org',
  CHANGE_PERMISSIONS: 'Change Permissions',
  CHANGE_PERMISSIONS_MODAL_TEXT: 'Are you sure you want to change permissions for <b>{username}</b> ?',
  CHANGED: 'changed',
  CHANGED_LABEL: 'Changed',
  CHANGES: '$0 Changes',
  CHANGES_FROM: '$0 from $1',
  CHATTER: 'Chatter',
  CHATTER_PREFERENCES: 'Chatter Preferences',
  CHATTER_DISABLED_IN_SALESFORCE: 'Chatter disabled in Salesforce Organization',
  CHATTER_POSTS: 'Chatter Posts',
  CHECK_BACK_LATER: 'Check back later.',
  CHOOSE_DATE: 'Choose another date.',
  CHOOSE_TYPE: 'Choose Payment Type',
  CHOOSE_CSV: 'Choose CSV',
  CLASSIC: 'Classic',
  CLICK_DONE: 'Click “Done” to return to your organizations backup Dashboard.',
  CLICK_TO_STOP: 'Click to stop $0',
  CLICK_TO_STOP_TOOLTIP: 'Click to stop {actionName}',
  CLIENT_ID: 'Client ID',
  CLOSE: 'Close',
  CODE: 'code',
  CODE_LABEL: 'Code',
  COLLAPSE_ALL_LABEL: 'Collapse All',
  CODE_ERROR: 'Code {value}: ',
  COLLAPSE_ALL: 'collapse all',
  COMMA: ',',
  COMPARE: 'compare',
  COMPARE_AGAINST: 'Compare against',
  COMPARE_AGAINST_NOT_BEFORE_BACKUP: 'The metadata to compare against cannot be before backed up metadata',
  COMPARE_AGAINST_SAME_ORG: 'Compare against same org',
  COMPARE_METADATA: 'Compare Metadata',
  METADATA_COMPONENTS: 'Metadata Components',
  COMPARE_METADATA_COMPONENTS: 'Compare Metadata Components',
  COMPARE_METADATA_COMPONENTS_COMPLETE:
    'Once the comparison is complete, you will be able to view which files were added, deleted, or updated, and view a side-by-side comparison of the changes in the updated files.',
  COMPARE_METADATA_COMPONENTS_CROSS_ORG: 'Compare Metadata Components Between Two Orgs',
  COMPARE_METADATA_COMPONENTS_CROSS_ORG_AUTH:
    'Authorize using your credentials for any production org, developer org, or sandboxes.',
  COMPARE_METADATA_COMPONENTS_CROSS_ORG_CHOOSE:
    'Choose “Different org” to compare backed up metadata in this org with live metadata of a different org, even if Spanning is not installed in the different org.',
  COMPARE_METADATA_COMPONENTS_NEXT:
    'In the next step, you will have the option to select which metadata components you would like to compare.',
  COMPARE_METADATA_COMPONENTS_OPTION_EXPORT:
    'You will have an option to export out files from the side-by-side comparison view once the comparison is complete.',
  COMPARE_METADATA_COMPONENTS_OPTION_RESTORE:
    'You will have an option to continue to Metadata Restore from comparison results if you are comparing current components of this org or a different org.',
  COMPARE_METADATA_COMPONENTS_THIS_ORG: 'Compare Metadata Components for This Org',
  COMPARE_METADATA_COMPONENTS_THIS_ORG_CHOOSE_BACKUP:
    'Choose a different point-in-time backup to compare metadata between two backups of this (the same) org.',
  COMPARE_METADATA_COMPONENTS_THIS_ORG_CHOOSE_CURRENT:
    'Choose “Current components” to compare backed up metadata with live metadata in this org.',
  COMPARE_METADATA_COMPONENTS_USE:
    'Use this feature to compare backed up metadata in this org with metadata from a different point-in-time backup, current metadata components of this org, or current metadata components of a different Salesforce org.',
  COMPARING_METADATA: 'comparing metadata components',
  COMPARING_METADATA_MASK_MSG:
    'You can choose to wait here while the comparison is running, or navigate back to the Spanning Dashboard. You will be notified via email and Chatter when the comparison completes.',
  COMPARING_METADATA_MASK_TITLE: 'Comparing Metadata',
  COMPARING_OBJECTS: 'Comparing ... objects',
  COMPLETE_RESTORE: 'COMPLETE RESTORE',
  COMPLETED: 'COMPLETED',
  COMPLETED_LOWERCASE: 'completed',
  COMPLETED_STEPS: 'I have completed the steps listed above',
  COMPONENTS_FROM_BACKUP: 'Components from $0 backup',
  COMPONENTS_FROM_BACKUP_LABEL: 'Components from {date} backup',
  CONFIGURATION: 'configuration',
  CONFIGURED_ALERT_RULES: 'Configured Alerts',
  CONDITIONS: 'Conditions',
  CONFIRM: 'Confirm',
  CONFIRM_AUTH: 'Confirm that you are authenticated and have "Modify All Data" permission for the destination org',
  CONFIRM_CHANGES: 'Confirm changes',
  CONFIRM_COMPARE_EXIT: ' Are you sure you want to exit this Metadata compare?',
  CONFIRM_DISABLE_AUTOMATION_TITLE: 'Are you sure you want to disable automation?',
  CONFIRM_DISABLE_AUTOMATION_DESC:
    'I understand that during restore, apex triggers and workflow rules will be disabled for affected objects. For flows, they will be disabled for organization.',
  CONFIRM_EXPORT_RECORD: '1 $0 Record',
  CONFIRM_EXPORT_RECORDS: '$0 $1 Records',
  CONFIRM_RESTORE: 'confirm restore',
  CONFIRM_EXPORT: 'confirm export',
  CONFIRM_RESTORE_EXIT: ' Are you sure you want to exit this restore?',
  CONFIRM_EXPORT_EXIT: 'Are you sure you want to exit this export?',
  CONFIRM_GDPR_REQUEST_EXIT: 'Are you sure you want to exit this gdpr request?',
  CONFIRM_RESTORE_RECORD: '1 $0 Record',
  CONFIRM_RESTORE_RECORDS: '$0 $1 Records',
  CONFIRM_RESTORE_OBJECT: '1 $0 Object',
  CONFIRM_RESTORE_OBJECTS: '$0 $1 Objects',
  CONFIRM_WIZARD_EXIT: ' Are you sure you want to exit this operation?',
  CONTACT_FORM_TEXT:
    "In order to get your organization set up for Invoicing, we'll need to speak with you over the phone. Please enter your information and click Next.",
  CONTACT_FORM_TEXT_RENEW:
    "In order to process your renewal, we'll need to speak with you over the phone. Please enter your information and click Next.",
  CONTACT_SUPPORT: 'contact support',
  CONTACTS: 'Contacts',
  CONTENT_FROM_BACKUP: 'Content from $0 Backup',
  CONTINUE: 'Continue?',
  CONTINUE_TO_RESTORE: 'Continue to restore',
  COST: 'Cost',
  COST_PER_USER: 'Cost Per User',
  COST_US: '$$0 USD/year (without sales tax)',
  COST_US_WITH_TAXES: '$$0 USD/year ($$1 + $$2 estimated sales tax)*',
  COUNT: 'count',
  COUNT_LABEL: 'Count',
  COUNT_ASC: 'Count - Ascending',
  COUNT_DESC: 'Count - Descending',
  CREATE_NEW: 'Create New',
  CREATED: 'New or Updated',
  CREATE_NEW_ALERT: 'Create New Alert',
  CREATE_NEW_ALERT_DESC: 'Please select the Triggers and Conditions for this alert.',
  CREDIT_EXPIRES: '<span class="sbsf-payment-light-text">Expires</span> $0/$1',
  CREDIT_NICKNAME: '<span class="sbsf-payment-light-text">$0 ending in</span> $1',
  CROSS_ORG_RESTORE: 'Cross-Org Restore',
  CROSS_ORG_METADATA_RESTORE: 'Cross-Org Metadata Restore',
  CROSS_ORG_RESTORE_COMPLETED_FROM_CSV: 'Cross-Org Restore has been completed for these records on $0',
  CROSS_ORG_RESTORE_MORE_INFO_LINK: `<a href="$0" target="_blank">For more information, click here</a>`,
  CSV_VERIFICATION_FOR_EXPORT: 'CSV Verification for export',
  CSV_VERIFICATION_FOR_BULK_RESTORE: 'CSV Verification for restore',
  CURRENT_COMPONENTS: 'Current components',
  CURRENT_COMPONENTS_AS_OF: 'Components as of {date}',
  CURRENT_COMPONENTS_AS_OF_CROSS_ORG: 'Components from {orgName} as of {date}',
  CURRENT_VALUE: 'Current Value',
  CURRENT_VERSION: 'Current Version',
  CURRENT_OBJECT: 'Current Object',
  CUSTOM: 'Custom',
  CUSTOM_TIME_BACKUP: 'Scheduled Backup',
  CVC: 'CVC',
  CVC_PLACEHOLDER: '123',
  DAILY: 'Daily',
  DATA_DELETION_AND_VERIFICATION: 'Data Deletion and Anonymization Verification',
  DATA_DELETION_AND_OVERWRITING: 'Data Deletion and Anonymization Overwriting',
  DAILY_AUTOMATED_SCHEDULE: 'Daily Automated Backup Schedule',
  DASHBOARD: 'Dashboard',
  DASHBOARD_CONFIGURATION: 'Dashboard Configuration',
  DASHBOARD_PREFERENCES: 'Dashboard Preferences',
  DASHBOARD_PREFERENCES_DESC:
    'Choose the object types you want displayed on the dashboard and in status report emails.',
  DASHBOARD_PREFERENCES_HELP:
    "You'll be able to choose the object types you want displayed on the dashboard and in status report emails once you have at least one backup.",
  DASHBOARD_CONFIGURATION_DESC:
    'Choose the object types you want displayed on the dashboard and in status summary emails.',
  DASHBOARD_CONFIGURATION_HELP:
    "You'll be able to choose the object types you want displayed on the dashboard and in status report emails once you have at least one backup.",
  DATA_STORED_IN: 'Data stored in $0 data center',
  DATA_CENTER: 'Data stored in <b>{location}</b> data center',
  DATA_TYPE: 'Data Type',
  DATE: 'Date',
  DATE_CREATED: 'Date Created',
  DAY_LEFT: '1 day left',
  DAYS_LEFT: '$0 days left',
  DAY_REMAINING: '1 Day Remaining',
  DAYS: 'Days',
  DAYS_REMAINING: '$0 Days Remaining',
  DECREASES: 'decreases',
  DELETE: 'Delete',
  DELETE_SECRET: 'Delete Secret',
  DELETED: 'Deleted',
  DELETED_BETWEEN: 'Deleted between',
  DELETED_ITEMS: 'Deleted Items',
  DELETED_ITEMS_RESTORE: 'Deleted Items Restore',
  DELETED_OBJECTS: 'Permanently deleted Objects are restored as new records with new IDs',
  DELETED_OBJECT_TYPE_EXCLUSION: "Added ''{deletedObjectTypes}'' objects to backup (previously excluded)",
  DELETED_OBJECT_TYPE_FIELD_EXCLUSION: "Added ''{deletedObjectTypes}'' objects fields to backup (previously excluded)",
  DELETED_OBJECT_TYPE_EXCLUSION_LABEL: 'Added Objects to Backup',
  DELETED_OBJECT_TYPE_FIELD_EXCLUSION_LABEL: 'Added Objects Fields to Backup',
  DELETE_PRESET: 'OK to delete preset "$0"?',
  DELETION: 'Deletion',
  DESCRIPTION_LABEL: 'Description',
  DESCRIPTION: 'description',
  DESTINATION: 'destination',
  DETAILS: 'Details',
  DETECTED: '$0 detected',
  DIFFERENCE: '1 difference',
  DIFFERENCES: '$0 differences',
  DIFFERENT_ORG: 'Different org',
  DIFFERENT_ORGANIZATION: 'Different organization',
  DISABLE_SALESFORCE_AUTOMATION: 'Disable Apex triggers, flows and workflows',
  DISABLE_SALESFORCE_AUTOMATION_DESC: 'All Apex triggers, flows and workflows will be enabled after restore session',
  DISABLED_AUTOMATION: 'Disabled automation',
  DISABLED_ITEMS_COUNT: 'Disabled items count',
  DISCOUNT: 'Discount',
  DISCOUNT_PRICE_USER: 'Discount Price Per User',
  DONE: 'Done',
  DOWNLOADS: 'Downloads',
  DOWNLOAD_BATCH_OUTPUT: 'Download Batch Output',
  DOWNLOAD_CSV: 'Download CSV',
  DOWNLOAD_ERROR_CSV: 'Download Error List CSV',
  DOWNLOAD_ERROR: 'Error downloading csv',
  DOWNLOAD_EXPORT: 'Download Export ($0)',
  DOWNLOAD_EXPORT_LABEL: 'Download Export',
  DOWNLOAD_FAILED_ITEMS: 'Download List of Failed Items',
  DOWNLOAD_LIST: 'download list',
  DOWNLOAD_LIST_TOOLTIP: 'Download a CSV of IDs that did not match records in the selected backup',
  DOWNLOAD_START: 'Your download will start shortly',
  DOWNLOADED_BY: 'Downloaded By',
  DOWNLOADED: '$0 Downloaded',
  DUPLICATE_COUNT: '$0 Duplicate IDs found',
  DUPLICATE_COUNT_DESC: 'Duplicate IDs were found in the csv. Records will only be updated once',
  DUPLICATE_ALERT_ERROR: '<b>Duplicate Error</b> An alert already exists with this definition.',
  DURATION: 'Duration',
  DRAWER_LABEL_USER: 'User',
  DRAWER_LABEL_DATE: 'Date',
  DRAWER_LABEL_EVENT_TYPE: 'Event Type',
  DRAWER_EVENT_TYPE_PLACEHOLDER: 'Select Event Type...',
  DRAWER_INPUT_PLACEHOLDER_USER: 'Search Users...',
  EDIT: 'Change',
  EDIT_ALERT: 'Edit Alert',
  EDIT_ALERT_RULES: 'Edit Alerts',
  EDIT_ALERT_RULES_TOOLTIP: 'Add or modify alertSettings',
  EDIT_ALERT_RULES_DONE_TOOLTIP: 'Finish editing alertSettings',
  EDIT_BACKUP_SCHEDULE: 'Edit Backup Schedule',
  EDIT_CARD: 'change card',
  EDIT_CREDIT_CARD: 'Change Credit Card',
  EDIT_LABEL: 'edit',
  EDIT_PERMISSIONS: 'Edit Permissions',
  EDIT_PERMISSIONS_TOOLTIP: 'Add or remove permissions of the users',
  EDIT_PERMISSIONS_DONE_TOOLTIP: 'Finish editing permissions',
  EDIT_RECEIPT_INFO_ETC: 'Edit Receipt Info (VAT, etc)',
  EDIT_SEARCH: 'Edit Search',
  EDIT_SEARCH_TOOLTIP: 'Modify the search criteria',
  EDIT_SETTINGS_LABEL: 'edit settings',
  EMAIL: 'Email',
  EMAIL_ADDRESS: 'Email Address',
  EMAIL_PREFERENCES: 'Email Preferences',
  ENABLE_AUTOMATION_BACK: 'Enable automation back',
  ENABLE_PERMISSION:
    'Enable "Update Records with Inactive Owners" permission or temporarily activate the Inactive Owners',
  ENABLE_BACKUP_SCHEDULE: 'Enable User Scheduled Backups',
  ENABLE_RULE_BASED_ALERTS: 'Enable Rule-Based Alerts',
  ENABLE_RULE_BASED_ALERTS_DESC: 'Enabling will send alerts to specified email addresses and to your Chatter Feed.',
  ENABLE_CHATTER_FEED_NOTIFICATIONS: 'Enable Chatter Feed Notifications',
  ENABLE_CHATTER_DESC: 'Enabling will post Spanning Backup Events to your Chatter Feed.',
  ENABLED_ITEMS_COUNT: 'Enabled items count',
  ENDING_IN: 'ending in',
  ENSURE_DESTINATION_SETUP:
    'Ensure that the destination org is setup with the same customizations and metadata as the source org',
  ENSURE_SPACE:
    'Ensure the destination org will have enough storage space to accommodate the data you select from the source org',
  ENTER_CONTACT_INFO: 'Enter Your Contact Info',
  ENTER_CREDIT_CARD: 'Enter your credit card info',
  ENTER_NEW_FIELD_VALUE: 'Enter new field value',
  ERROR: 'error',
  ERRORS_LABEL: 'Error',
  ERROR_CODE: 'error code: ',
  ERROR_TYPE: 'error type',
  ERROR_TYPE_LABEL: 'Error Type',
  ERROR_TYPE_TEXT_WITH_COUNT: '$0 ($1)',
  ERRORS: 'errors',
  ERROR_LOADING_DATA: 'Loading error',
  ERROR_SAVING_DATA: 'Saving error',
  EVENT: 'Event',
  EXISTING_CARD_HEADER:
    'You already have a credit card on file. If you wish to edit or remove this card, please click the corresponding link below. Otherwise press "Next" to continue.',
  EXIT_RESTORE: 'Exit Restore?',
  EXPIRED: 'Expired',
  EXPIRED_MESSAGE_MOBILE:
    "We're sorry, but your organization's Spanning Backup license has expired. Please sign in to your Salesforce account in a web browser to renew.",
  EXPIRED_MESSAGE: "We're sorry, but your organization's Spanning Backup license has expired.",
  EXPIRES: 'Expires',
  EXPIRES_PARENS: '(Expires $0)',
  EXPORT: 'Export',
  EXPORT_OPTION: 'You will have the option to export your Objects for review before completing the restore',
  EXPORT_SETTINGS: 'Export Settings',
  EXPORTING: 'EXPORTING $0',
  EXPORT_ALL: 'EXPORT ALL',
  EXPORT_BACKUP: 'EXPORT BACKUP',
  EXPORT_CANCELLED: 'Export cancelled. Click here to view.',
  EXPORT_COMPLETED: 'Export complete. Click here to view and download',
  EXPORT_EXPIRED: 'Export expired on $0',
  EXPORT_FAILED_ITEMS: 'Export failed items',
  EXPORT_METADATA_ERROR: 'An error occurred while trying to export metadata',
  EXPORT_NUM: 'export ($0)',
  EXPORT_PROGRESS: 'EXPORT $0',
  EXTERNAL_USER_LOGGED_IN: 'External user has logged in',
  EXTRA_INFO_EXAMPLE: 'Examples: Value Added Tax (VAT), address, etc.',
  EXTRA_INFO_MSG: 'Information included here will be added to receipts.',
  FAILED: 'Failed',
  FAILED_TO_COMPLETE: 'Failed to complete',
  FIELD: 'Field',
  FILTER: 'Filter',
  FIELD_TYPE: 'field type',
  FIELDS: 'Fields',
  FIELD_NAME: 'Field name',
  FIELD_NAME_LABEL: 'Field Name',
  FIELD_VALUE: '1 Field Value',
  FIELD_VALUES: '$0 Field Values',
  FIND: 'Find',
  FIRST_NAME: 'First Name',
  FLOWS: 'Flows',
  FOR_MORE_INFORMATION_CLICK_HERE: 'For more information, click here',
  FREE: 'Free',
  FREQUENCY_STATUS_REPORTS: 'Email frequency',
  FROM: 'From',
  FROM_BACKUP_BATCH: 'From backup batch:',
  FROM_BACKUP_ON: 'from backup on',
  FULL_NAME: 'Full Name',
  GDPR: 'GDPR',
  GDPR_REQUEST_SHORT_DESCRIPTION:
    'Use this feature to anonymize or delete sensitive records and data from your Spanning Backup for Salesforce environment. This can be used to remain in compliance with regional regulations such as GDPR, CCPA, etc.',
  GDPR_REQUEST_NO_PRODUCTION_DATA_AFFECTED: 'NO SALESFORCE PRODUCTION DATA IS AFFECTED BY THIS PROCESS.',
  GDPR_REQUEST_DESC:
    'This feature allows you to anonymize or delete sensitive records and data from your Spanning Backup for Salesforce environment. This can be used to remain in compliance with regional regulations such as GDPR, CCPA, etc.',
  GDPR_REQUEST_NOTE: 'Note: No Salesforce production data is affected by this process.',
  GDPR_OVERWRITING: 'GDPR Overwriting',
  GDPR_DELETION: 'GDPR Deletion',
  GDPR_OPERATION: 'GDPR Operation',
  GDPR_VERIFICATION: 'GDPR Verification',
  GDPR_STEP_TWO_INSTRUCTION: 'Click "Next".',
  GDPR_NOT_FOUND_RECORD_VERSION_IN_CHUNK: 'Record not found in storage',
  GDPR_NOT_FOUND_RECORD_VERSION_IN_CHUNK_DESC: 'The record was backed up but its data was not found in storage',
  GENERATE_NEW_SECRET: 'Generate New Secret',
  GENERATE_SECRET: 'Generate Secret',
  GET_STARTED: 'Get Started!',
  GO_PREVIOUS: 'Go to Previous Step',
  GO_TO_DASHBOARD: 'Go to Dashboard',
  GRANULAR: 'Granular',
  GROUP: 'Group',
  HANDLE_MULTIPLE_RECORDS: 'Handle multiple records',
  HANDLE_RECORDS: 'Handle records',
  HELP_MENU_IDEAS_PORTAL: 'Ideas Portal',
  HELP_MODAL_TEXT:
    '<span>The look and feel of Spanning Backup for Salesforce has been updated to support the Salesforce Lightning Experience. If you have questions, please contact support via the <a href="https://one.kaseya.com/support">KaseyaOne Portal</a>.</span>',
  HELP_ON_WAY: 'Help is on the way!',
  HIDE: 'Hide',
  HIDE_ERRORS: 'Hide {errors} Errors',
  HIDE_METADATA: 'Hide Metadata',
  HIDE_SECRET: 'Hide Secret',
  HISTORY: 'history',
  HISTORY_TAB: 'History',
  HOUR: '$0 hour',
  HOURS: '$0 hours',
  HOUR_LABEL: 'Hour',
  HOURS_LABEL: 'Hours',
  ID: 'ID',
  IDENTICAL_CONTENT: 'Content is identical',
  IGNORE_WARNINGS_ENABLED: 'Spanning will ignore warnings from Salesforce during this metadata restore operation only.',
  IN_BACKUP: 'In Backup',
  IN_FOLLOWING_STEPS: `You can search across backups for deleted and updated records, or you can <a href="$0" target="_blank">upload a CSV list</a> of object IDs`,
  IN_PROGRESS: 'In-Progress',
  IN_FOLLOWING_STEPS_EXPORT:
    'You can search across backups for deleted and updated records, or you can upload a CSV list of object IDs',
  IN_FOLLOWING_STEPS_OVERWRITING_GDPR_REQUEST:
    'The "Overwrite" operation will overwrite all data values with fake data. It will not change the data structure.<div>Strings are overwritten with "XXXXXXXXXXXXX".</div><div>Numbers are overwritten with 0.\nBooleans are overwritten with false.</div><div>Dates are overwritten with Jan 1, 1970.</div><div>Blobs are overwritten with a file that contains the string "This file has been overwritten as part of a GDPR request"</div><div><b>It is a preferred way to perform a GDPR request.</b></div>',
  IN_FOLLOWING_STEPS_DELETION_GDPR_REQUEST:
    'The "Delete" operation will remove the records itself and their children. It will change the data structure this way. <div>The counters (the count of saved record, deleted record etc) will not be changed.</div><div>Be careful since after the structure change, you might not be able to correctly perform some operations like "Restore" because you can delete the children that some records depend on.</div>',
  IN_FOLLOWING_STEPS_ATTENTION_GDPR_REQUEST:
    '<b>Attention</b>. You should basically use the "Overwrite" option since the records\' data will be overwritten with default values and the data structure will not be changed and all future operations like "Restore" will work correctly. Use "Delete" option only if you have a big reason to strongly delete the records.',
  INACTIVE_ALERTS: 'Inactive Alerts',
  INFINITE: 'Infinite',
  INCLUDE_CHILD_RECORDS: 'You will have the option to include child (detail) records when restoring deleted records',
  INCLUDE_CHILDREN: 'Include children of records',
  INCLUDE_CHILDREN_CROSS_ORG: 'Include child records',
  INCLUDE_CHILDREN_DESC: 'When restoring records, also restore related children and grandchildren.',
  INCLUDE_CHILDREN_DESC_CROSS_ORG: 'When restoring records, also restore related children and grandchildren.',
  INCLUDE_CHILDREN_DESC_EXPORT:
    'When exporting deleted records, also export related children and grandchildren. Children of updated records will not be exported.',
  INITIATED_BY: 'Initiated By',
  INSERTED: 'Inserted',
  INVALID_COUNT: '$0 IDs not found',
  INVALID_COUNT_DESC: 'Download a list of object IDs not found in the selected backup',
  INVALID_EMAIL_ADDRESS: 'Please enter a valid email address',
  INVOICE_VIEW_TEXT:
    'One of our sales representatives will contact you within one business day. If you would rather not wait, you can contact us via phone or email.',
  INTEGRATIONS: 'Integrations',
  IS: 'is',
  IS_AT_MOST: 'is at most',
  IS_AT_LEAST: 'is at least',
  IT_COMPLETE: 'Kaseya IT Complete Features',
  IT_COMPLETE_BIND_ORGANIZATION: 'IT Complete organization has been bound',
  IT_COMPLETE_UNBIND_ORGANIZATION: 'IT Complete organization has been unbound',
  IT_COMPLETE_FEATURE: 'Allow Kaseya IT Complete login for administrators',
  IT_COMPLETE_FEATURE_CHANGED: 'IT Complete feature status has been changed',
  IT_COMPLETE_ORGANIZATION: 'Linked K1 Organization:',
  ITEM: 'item',
  ITEM_TYPE: 'Item Type',
  ITEMS: 'items',
  'ITEM(S)': 'Item(s)',
  ITEM_FOUND: '1 item found',
  ITEMS_FOUND: '$0 items found',
  ITEMS_FOUND_LABEL: 'items found',
  ITEMS_FROM_METADATA_COMPARISON: 'Items from Metadata comparison',
  ITEMS_RESTORED_LABEL: 'Items Restored',
  ITEMS_RESTORED: '($0/$1 items restored)',
  ITEMS_RESTORED_FROM: '($0/$1 items restored from Backup on $2)',
  INCREASES: 'increases',
  INVALID_DATE: 'No backup data for selected date',
  KEY: 'Key',
  KASEYA_LINK_TOOLTIP: 'Kaseya.com',
  KASEYA_SUCCESS_NOTIFICATION_TITLE: 'Success',
  KASEYA_SUCCESS_NOTIFICATION_DESCRIPTION: 'Log In With KaseyaOne has been enabled.',
  LARGE_CONTENT: 'Content too large to render. Please export to view.',
  LAST_8_BACKUPS: 'Last 8 Backups',
  LAST_30_BACKUPS: 'Last 30 Backups',
  LAST_DAY: 'last day',
  LAST_HOUR: 'last hour',
  LAST_N_DAYS: 'last $0 days',
  LAST_NUMBER_DAYS: 'last {number} days',
  LAST_N_HOURS: 'last $0 hours',
  LAST_NUMBER_HOURS: 'last {number} hours',
  LAST_MODIFIED_DATE: 'Last Modified Date',
  LAST_NAME: 'Last Name',
  LATEST: 'Latest',
  LATEST_BACKUP: 'Latest Backup',
  LATEST_VERSION: 'Latest Version',
  LEADS: 'Leads',
  LEARN_MORE: 'Learn More',
  LETS_GET_STARTED: 'Lets Get Started',
  LESS_THAN_1_MINUTE: '< 1 minute',
  LEVEL_CHILD: '$0 level child',
  CHILD_LEVEL:
    '{level, selectordinal, one {#st level child} two {#nd level child} few {#rd level child} other {#th level child}}',
  LICENSE_EXPIRED: 'Your License Has Expired',
  LICENSE_PURCHASED: 'Licenses Purchased',
  LIMIT: 'Limit',
  LINK_EXTERNAL_ORGANIZATION: 'Link external organization',
  LOAD_MORE: 'Load More',
  LOADING: 'loading',
  LOADING_MSG: 'loading',
  LOADING_MSG_WITH_DOTS: 'loading...',
  COMPLETE: 'complete',
  COMPLETE_LABEL: 'Complete',
  LOOKUP: 'lookup',
  LOGIN_WAIT: 'Please wait, we are login you in...',
  MAIL_TO_SUPPORT: 'https://one.kaseya.com/support',
  MAKE_A_SELECTION_CONTINUE: 'Please make a selection and press Next to continue.',
  MANUAL_BACKUP: 'Manual Backup',
  MANUAL_BACKUPS: 'Manual Backups',
  MASTER_DETAIL: 'Master detail',
  MATCH: 'match',
  MATCH_LABEL: 'Match',
  METADATA: 'metadata',
  METADATA_COMPARE_EXPIRED: 'Metadata Comparison has expired',
  METADATA_COMPARE_EXPIRED_INFO: 'Metadata Comparisons expire after 14 days. Please run another comparison',
  METADATA_COMPARE_SUBMIT_FAILED: 'There was a problem submitting the metadata compare. Please try again.',
  METADATA_COMPARE: 'Metadata Compare',
  METADATA_COMPARE_FAILED:
    'Metadata Compare has failed. Please contact support via the {link} if the problem persists.',
  METADATA_COMPARISON_EXPIRED: 'Metadata comparison expires after 14 days<br/>Please run another',
  METADATA_NAME: 'Metadata Name',
  METADATA_ONLY: 'metadata only',
  METADATA_RESTORE: 'Metadata Restore',
  METADATA_RESTORE_CONFIRMATION:
    'You are about to perform a Metadata restore. This process cannot be undone. Click ‘Confirm’ to begin the restore process.',
  METADATA_TYPE_WITH_COUNT: '$0 - $1',
  MODIFIED: 'modified',
  MODIFIED_BETWEEN: 'Modified Between',
  MODIFIED_BETWEEN_TOOLTIP: 'Search will narrow down results based on System Modstamp field.',
  MULTI_RECORD_RESTORE: 'Multi-Record Restore',
  MY_CHATTER_FEED: 'My Chatter Feed',
  MIN_VALUE_IS: 'Minimum value is {num}',
  N_BACKUPS: '$0 backups',
  N_CALL_LIMIT: '$0 call limit',
  N_CHANGES_FROM: '{0} changes from {1}',
  N_DAYS: '$0 days',
  N_HOURS: '$0 hours',
  N_METADATA_COMPONENT_TYPES: '$0 Metadata types',
  N_MINUTES: '$0 minutes',
  N_RECORDS: '$0 records',
  MINUTES_LABEL: 'Minutes',
  MINUTE_LABEL: 'Minute',
  NAME: 'Name',
  NAME_OR_ID: 'Name/ID',
  NEW: 'New',
  NEW_OR_UPDATED: 'New or Updated',
  NEXT: 'Next',
  NEXT_AUTOMATED_BACKUP: 'Your next automated backup is scheduled for $0 $1.',
  NEXT_BACKUP: 'Next Backup',
  NEXT_BACKUP_INFO: 'Your next automated backup is scheduled for',
  NEXT_ITEM: 'Next Item',
  NEXT_VERSION: 'Next Version',
  NEVER: 'Never',
  NEW_VALUE: 'new value',
  NEW_VALUE_LABEL: 'New Value',
  NO: 'no',
  NO_ACTIVITY: 'No Activity',
  NO_ALERTS_FOUND: 'No Alerts Found',
  NO_ADDRESS_SPECIFIED: 'No Address Specified',
  NO_ALERT_RULES: 'You have not defined any alertSettings.',
  NO_BACKUPS_AVAILABLE: 'No Backups Available',
  NO_BACKUPS_DATE: 'Sorry, no backups are available on this date.',
  NO_BACKUPS_YET: 'There are no backups yet.',
  NO_BACKUPS_YET_SHORT: 'No Backups Yet',
  NO_CARD: "We don't have any Credit Card information for you on file. Please ",
  NO_CHANGES: 'No Changes',
  NO_CREATEABLE_OR_UPDATEABLE_FIELDS: 'No createable or updateable fields',
  NO_CURRENT_ACTIVITY: 'No Current Activities',
  NO_DIFF: 'No differences detected.',
  NO_RECENT_ACTIVITY: 'No Recent Activity',
  NO_RECORDS_FOUND: 'No records found',
  NO_ITEMS_TO_RESTORE: 'There are no items to restore',
  NO_ITEMS_FOUND_TO_RESTORE: 'No records found to restore',
  NO_ITEMS_FOUND_TO_RESTORE_DESC: 'No records were found to restore from selected search criteria',
  NO_MATCHING_RECORDS: 'No matching records',
  NO_NEWER_BACKUPS_TOOLTIP: 'There are no newer backups',
  NO_OLDER_BACKUPS_TOOLTIP: 'There are no older backups',
  NO_RECORDS_RESTORED:
    'None of the selected records were restored. Please contact  <a class="sbsf-link" target="_top" href="https://one.kaseya.com/support"> support team </a> for further assistance.',
  NO_RESTORABLE_FIELDS: 'There are no restorable fields in the selected records.',
  NO_SECRET_GENERATED: 'No secret generated',
  NO_SECRET_GENERATED_YET: 'No Secret has been generated yet',
  NO_SCHEDULED_BACKUPS: 'There are no scheduled backups',
  NO_SETTINGS_ACTIVITY: 'No audit events found',
  NO_UPDATEABLE_FIELDS: 'There are no updateable fields in the selected records.',
  NON_ADMIN_MSG: 'Allow admin access only',
  NON_RESTORABLE: 'Non-restorable',
  NOT: 'NOT',
  NOT_POSTING_EVENTS_CHATTER: 'Not posting events to chatter',
  NOT_RESTORABLE_FIELDS_MSG: '* Read-only field shown for informational purposes only. Data cannot be restored.',
  NOT_RESTORABLE_TYPE: 'This object type is not restorable',
  NOT_RESTORED: 'Not Restored',
  NOT_ENOUGH_LICENSES: 'Not Enough Licenses',
  NOTIFICATION: 'notification',
  NOTIFICATIONS: 'Notifications',
  NOTIFY_ME_WHEN: 'Notify me when...',
  NUMBER_OF_RECORDS: 'Number of Records...',
  NUM_ADDED: '$0 Added',
  NUM_ADDED_LABEL: '{num} Added',
  NUM_CHANGED: '$0 Changed',
  NUM_CHANGED_LABEL: '{num} Changed',
  NUM_DELETED: '$0 Deleted',
  NUM_DELETED_LABEL: '{num} Deleted',
  NUM_ERRORS: '$0 Errors',
  NUM_NEW: '$0 New',
  NUM_OF_USERS: 'Number of Users',
  NUM_UPDATED: '$0 Updated',
  NUM_WARNINGS: '$0 Warnings',
  NUM_UNDELETED: '$0 Undeleted',
  NA: 'n/a',
  OAUTH_CHANGE_ACCOUNT: 'Would you like to change the authentication account to',
  OAUTH_NO_CHANGE: 'You cannot change the authentication account until you sign into Salesforce as another user.',
  OAUTH_USER_MSG:
    'In order to change the API authentication account, you must be signed into that account.  The following account is currently being used to authenticate with the API:',
  OBJECT: 'object',
  OBJECTS: 'Objects',
  OBJECT_FIELD: 'Object field',
  OBJECT_ID: 'Object ID',
  OBJECT_RESTORE: 'Object Restore',
  OBJECT_RESTORED: 'Object Restored',
  OBJECT_SEARCH_TEXT_TOOLTIP: 'Leave blank to show all objects',
  OBJECT_SELECTION_METHOD: 'Object Selection Method',
  OBJECT_TYPE: 'Object Type',
  OBJECTS_RESTORED: '($0/$1 objects restored)',
  OBJECTS_PROCESSED: 'Objects Processed',
  OF_LABEL: 'of',
  OF: 'of $0',
  OFF: 'off',
  OK: 'ok',
  OKAY: 'OKAY',
  ON: 'on',
  ONE_BACKUP: '1 backup',
  ONE_DAY: '1 day',
  ONE_HOUR: '1 hour',
  ONE_METADATA_COMPONENT_TYPE: '1 Metadata type',
  ONE_MINUTE: '1 minute',
  ONE_RECORD: '1 record',
  ONE_SEL_ATTACH: '1 attachment selected',
  ONE_SELECTED: ', 1 selected',
  ONLY_IN_ONE: 'Only in One',
  OPPORTUNITIES: 'Opportunities',
  ORDER_INFO: 'Order Info',
  ORG_ADDED_SUCCESSFULLY: 'Org added successfully.',
  ORGANIZATION_ID: 'Organization ID',
  ORGANIZATION_DATA_CHANGED: 'Organization data changed',
  ORGANIZATION_NAME: 'Organization Name',
  ORG_SUCCESSFULLY_AUTHORIZED: 'Org successfully authorized',
  OVERWRITE: 'overwrite values',
  OVERWRITE_LABEL: 'Overwrite Values',
  OVERWRITING: 'Overwriting',
  OVERWRITE_NAME: 'Overwrite',
  OVERWRITE_FIELD_VALUES: 'Overwrite field values during the restore process',
  OVERWRITE_SUMMARY: 'You have elected to overwrite $0 fields.',
  OVERWRITE_SUMMARY_SINGULAR: 'You have elected to overwrite 1 field.',
  OVERWRITE_VALUES: 'Overwrite field values during the restore process',
  OVERWRITE_VALUES_DESC: 'Replace field values for specific fields of Object Types during the restore process.',
  PAGE: 'Page',
  PAST: 'Past',
  PARTIAL: 'Partial',
  PAYMENT_INFO: 'payment',
  PAYMENT_INFO_LABEL: 'Payment Info',
  PAID: 'Active',
  PCT_DISCOUNT: '$0% Discount',
  PENDING: 'Pending',
  PERCENT: 'Percent',
  PERCENT_COMPLETE: '$0% Complete - $1 $2',
  PERCENT_PROTECTED: '$0% Complete',
  PERCENT_COMPLETE_DETAIL: '{percent}% Complete',
  PERFORM_GDPR_REQUEST: 'Perform GDPR request',
  PERFORM: 'Perform',
  PERMISSIONS: 'Permissions',
  PERMISSION_ASSIGNMENT_MSG: 'OK to assign the selected permissions?',
  PERMISSION_ASSIGNMENT_TITLE: 'Confirm assignment',
  PERMISSION_MISSED: 'Required permissions missed',
  PERMISSION_NAME_1: 'Backups',
  PERMISSION_NAME_2: 'Exports',
  PERMISSION_NAME_3: 'Metadata Compares',
  PERMISSION_NAME_4: 'Restores',
  PERMISSION_NAME_5: 'Settings',
  PERMISSION_NAME_6: 'API Usage',
  PERMISSION_NAME_7: 'Permissions',
  PERMISSION_NAME_9: 'Activity History',
  PERMISSION_NAME_10: 'Backup Data Deletion And Anonymization',
  PERMISSION_NAME_11: 'External API Key & Secret',
  PERMISSION_NAME_12: 'IT Complete Feature',
  PERMISSION_NAME_13: 'Retention',
  PERMISSION_UNSAVED_CHANGES_ALL_MSG: 'OK to discard unsaved changes to the permissions?',
  PERMISSION_UNSAVED_CHANGES_TITLE: 'Confirm loss of changes',
  PERMISSION_SETTINGS_DESC: 'Choose the user and permissions you want to assign to him.',
  PERMISSION_SAVED: 'Permissions saved',
  PERMISSION_SELF_REMOVE_ADMIN_MSG: 'You can not remove Administrator permission from yourself',
  PERMISSION_SELF_REMOVE_ADMIN_ERROR: '<b>Permission Error</b> You cannot remove the admin role from yourself.',
  PERMISSION_ASSIGN_OR_DEPRIVE_ADMIN_RESTRICTION_MSG:
    'Only Administrators can assign or deprive Administrator permission',
  PERMISSION_SPANNING_ADMINISTRATORS_DESC:
    'In order to add or remove Spanning Administrators, you must log in to your Salesforce account.',
  PER_YEAR: 'per year',
  PHONE: '1-855-295-8111',
  PLACEHOLDER_EMAIL: 'john.doe@email.com',
  PLACEHOLDER_FIRST_NAME: 'First Name',
  PLACEHOLDER_LAST_NAME: 'Last Name',
  PLACEHOLDER_PHONE: '555-555-5555',
  PLEASE_CONTACT: 'Please contact your administrator.',
  PLEASE_ENTER_CREDIT_CARD: 'Please enter your credit card information and press "Next" to continue.',
  PLEASE_TRY_AGAIN: 'Please try again.',
  PLUS_SIGN: '+',
  PLURALIZE_MINUTES: '{count, plural, one {# minute} other {# minutes}}',
  PLURALIZE_HOURS: '{count, plural, one {# hour} other {# hours}}',
  PLURALIZE_DAYS: '{count, plural, one {# day} other {# days}}',
  PLURALIZE_MONTHS: '{count, plural, one {# month} other {# months}}',
  PM: 'PM',
  POST_SPANNING_BACKUP_EVENTS_CHATTER: 'Post Spanning Backup Events to Chatter',
  POSTING_ADMIN_GROUP: 'Posting Admin/Group',
  POSTING_EVENTS_CHATTER: 'Posting events to chatter',
  POSTING_EVENTS_CHATTER_USER: 'Posting Spanning Backup Events to my Chatter Feed',
  POSTING_EVENTS_CHATTER_GROUP: 'Posting Spanning Backup Events to a Chatter Group',
  PREFERRED_BACKUP_TIME: 'Preferred Backup Start Time $0 $1',
  PREFERRED_BACKUP_START_TIME: 'preferred backup start time',
  PRESET_MODIFIED: 'Preset Modified',
  PRESET_UNSAVED_CHANGES: '<p>You have unsaved changes to preset "$0".</p><p>OK to continue?</p>',
  PRESET_UNSAVED_CHANGES_AND_CONTINUE:
    '<p>You have unsaved changes to preset "$0". If you continue, the restore will use the changes but the preset will not be updated.</p><p>OK to continue?</p>',
  PRESET_NAME_EXISTS:
    'The specified name is already in use. If you click "Save" you will replace the existing preset with that name.',
  PRESET_NAME_PLACEHOLDER: 'Preset name',
  PREV_ITEM: 'Prev Item',
  PREVIEW: 'Preview',
  PREVIEWING: 'Previewing',
  PREVIOUS: 'Previous',
  PREVIOUS_BACKUP: 'Previous Backup',
  PREVIOUS_ITEM: 'Previous Item',
  BACKED_UP_VALUE: 'Backed Up Value',
  PREVIOUS_VERSION: 'Previous Version',
  IN_PREPARING: 'In-Preparing',
  PROBLEM: 'Problem',
  PROCEED_NEXT: 'Proceed to Next Step',
  PROD_ORG: 'production org',
  PRICE: 'Price',
  PRICE_PER_USER: 'Price Per User',
  PRINT: 'Print',
  PURCHASE_PAGE: '$0/4',
  QUESTION_MARK: '?',
  QUEUED: 'queued',
  QUEUED_MSG: '$0 QUEUED',
  RANDOM: 'Random',
  RECEIPT: 'Receipt',
  RECEIPT_ID: 'Receipt ID',
  RECEIPT_PAYMENT_MSG: 'Payment for 1 year for Spanning Backup for Salesforce.com',
  RECEIPTS: 'Receipts',
  RECENT: 'Recent',
  RECENT_ACTIVITY: 'Recent Activity',
  RECENT_ACTIVITY_HELP: "You'll be able to see all your recent activity once you start backing up.",
  RECORD: 'Record',
  RECORD_ID: 'Record ID',
  RECORD_COUNT: '$0 of $1 records restored',
  RECORD_COUNT_TITLE: 'record count',
  RECORD_DESTINATION: 'to <span class="sbsf-record-destination">$0</span>',
  RECORD_NAME: 'Record Name',
  RECORD_NOT_FOUND: 'Record not found',
  RECORD_SEARCH_TEXT_TOOLTIP: 'Leave blank to match all records',
  RECORDS: 'Records',
  RECORDS_COUNT: 'Records Count',
  RECORDS_ONLY: 'records only',
  RECORDS_SETTING_SUMMARY: 'You have elected to $0 $1.',
  RECORDS_STATUS: 'Record Status',
  RECORDS_WHOSE_NAME_CONTAINS: 'records whose name or ID contains',
  CHOOSE_THE_RECORDS_WHOSE_NAME_STARTS_WITH: 'Choose the records whose name or ID starts with',
  RECYCLE_BIN:
    'Deleted Objects in the Recycle Bin are restored with same IDs, restoring all dependencies and maintaining IDs, regardless of selecting Classic or Granular Restore in Spanning.',
  RELATIONSHIP: 'Relationship',
  REMOVE: 'Remove',
  RENEW_SUPPORT_CONTACT_MOBILE:
    'Please contact support via the <a class="sbsf-link" target="_top" href="https://one.kaseya.com/support">KaseyaOne Portal</a> if you have any questions.',
  RENEW_SUPPORT_CONTACT:
    'Please renew, or contact support via the <a class="sbsf-link" target="_blank" rel="noopener noreferrer" href="https://one.kaseya.com/support">support team</a>  if you have any questions.',
  REFRESH: 'Refresh',
  REPAIR_LOOKUP_RELATIONSHIPS: 'Repair Lookup Relationships',
  REPAIR_LOOKUP_RELATIONSHIPS_DESC: 'Repair lookup relationships of other records that referenced to selected record',
  RESELLER_MIGRATION: 'Reseller has been changed',
  RESELLER_CHANGED: 'Reseller has been changed',
  RESTORE_LOOKUP_RELATIONSHIPS: 'Restore Lookup Relationships',
  RESTORE_LOOKUP_RELATIONSHIPS_DESC: 'Restore other records that referenced to selected record',
  RESTORE: 'Restore',
  RESTORE_MULTIPLE_RECORDS: 'Restore Multiple Records',
  EXPORT_MULTIPLE_RECORDS: 'Export Multiple Records',
  REST_API: 'Rest API',
  RESTORED: 'Restored',
  RESTORE_ATTACHMENTS: 'Restore Attachments',
  RESTORE_BATCH_DETAILS_TITLE: '$0 $1 $2 on $3',
  RESTORE_BY: 'By: $0',
  RESTORE_BY_FROM_COMPARE: 'By: $0 from Metadata Comparison run on $1',
  RESTORE_COMPLETE: 'restore complete',
  RESTORE_COMPLETED_FROM_CSV: 'Multi-Record Restore has been completed for these records on $0',
  RESTORE_DETAILS: 'Restore Details',
  RESTORE_FAILED: 'restore failed',
  RESTORE_FIELDS: 'restore fields',
  RESTORE_FIELDS_LABEL: 'Restore Fields',
  RESTORE_FILTER_SELECT_PLACEHOLDER: 'Filter objects',
  RESTORE_FILTER_METADATA_PLACEHOLDER: 'Search by keyword...',
  RESTORE_FROM_BACKUP: 'Restore from backup on',
  EXPORT_FROM_BACKUP: 'Export from backup on',
  RESTORE_IN_PROGRESS:
    'A restore is currently in progress. Please wait for it to complete before starting another one.',
  RESTORE_ITEMS_FROM_BACKUP_ON_DATE: 'Restore items from backup on $0',
  RESTORE_METADATA: 'Restore Metadata',
  RESTORE_METADATA_CONFIRM:
    'You will be able to confirm your selections before starting the restoration of the metadata items.',
  RESTORE_METADATA_CROSS_ORG: 'Restore Metadata Back Into a Different Org',
  RESTORE_METADATA_CROSS_ORG_AUTH:
    'Authorize using your credentials for any production org, developer org, or sandbox.',
  RESTORE_METADATA_CROSS_ORG_USAGE:
    'Use this feature to restore metadata from a previous point-in-time backup back into a different org, even if Spanning is not installed in the different org.',
  RESTORE_METADATA_MORE_INFO_LINK: `<a href="$0" target="_blank">For more information, click here</a>`,
  RESTORE_METADATA_NEXT_STEP:
    'In the next step, you will have the option to select which metadata items you would like to restore.',
  RESTORE_METADATA_NOTIFICATION:
    'Once the restore is complete, you will be notified via email and Chatter (if enabled).',
  RESTORE_METADATA_SAME_ORG: 'Restore Metadata Back Into This Org',
  RESTORE_METADATA_SAME_ORG_USAGE:
    'Use this feature to restore metadata from a previous point-in-time backup back into this org.',
  RESTORE_NOW: 'Restore Now',
  RESTORE_OBJECT_TYPE_DESC:
    'Restore updated or deleted records back into this org or to restore backed up data into a different org (e.g. sandbox seeding, org migration)',
  RESTORE_METADATA_TYPE_DESC:
    'Restore metadata files back into this org or to restore backed up metadata to a different org.',
  RESTORE_DIFFERENT_ORGANIZATION_DESC: 'Authorize production, development or sandbox organization',
  RESTORE_OBJ_OR_META: 'Restore Object Data or Metadata',
  RESTORE_OBJECT_DATA: 'Restore Object Data',
  RESTORE_OBJ_OR_META_DESC:
    'Search across backups or upload a CSV list. Permanently deleted objects get new IDs, while deleted objects in the \n Recycle Bin and updated objects are restored with their dependencies and existing IDs. More information <a>here.</a>',
  RESTORE_UPLOAD_CSV_DESC:
    'Choose or upload a CSV file containing 18 digit Object IDs of any Object Type with column heading "id".',
  RESTORE_UPLOAD_CSV_TOOLTIP: 'The maximum file size allowed 100MB',
  RESTORE_CSV_MISSING_IDS: 'Missing Object IDs.',
  RESTORE_CSV_MISSING_IDS_DESC:
    'Download a list of {idCount, plural, =1 {# missing object ID} other {# missing object IDs}} from the selected backup.',
  RESTORE_OBJ_OR_META_CHOOSE_OBJ:
    'Choose "Object" to restore updated or deleted records back into this org or to restore backed up data into a different org (e.g. sandbox seeding, org migration).',
  EXPORT_OBJ_OR_META_CHOOSE_OBJ:
    'Choose "Object" to export updated or deleted records back into this org or to export backed up data for different org (e.g. sandbox seeding, org migration).',
  RESTORE_OBJ_OR_META_CHOOSE_META:
    'Choose "Metadata" to restore metadata files back into this org or to restore backed up metadata to a different org.',
  EXPORT_OBJ_OR_META_CHOOSE_META:
    'Choose "Metadata" to export metadata files back into this org or to export backed up metadata for different org.',
  RESTORE_OBJ_OR_META_NOTIFICATION:
    'You will receive a notification via email and Chatter (if enabled) once the restoration is complete.',
  RESTORE_OBJ_OR_META_LOGGED: 'All restorations are logged in the immutable Activity History.',
  RESTORE_OVERWRITE_STRATEGY_CONSTANT: 'Specific Value',
  RESTORE_OVERWRITE_STRATEGY_RANDOM: 'Random Value',
  RESTORE_OVERWRITE_STRATEGY_RANDOM_TOOLTIP:
    'Enter the {random} command to generate a random value at the moment of restore',
  RESTORE_PARTIAL: 'partial restore',
  RESTORE_PREVIEW: 'Restore Preview',
  RESTORE_SEARCH_UNSAVED_CHANGES_MSG: 'OK to discard unsaved changes to the search criteria?',
  RESTORE_SEARCH_UNSAVED_CHANGES_TITLE: 'Confirm loss of changes',
  RESTORE_SETTINGS: 'restore settings',
  RESTORE_SPECIFIC_FIELDS: 'Restore specific fields of records',
  RESTORE_SPECIFIC_FIELDS_DESC:
    'Select specific fields to restore for records if the data loss is limited to a few fields',
  RESTORE_TYPE: 'Restore type',
  RESTORE_VERSION: 'Restore Version',
  RESTORED_VERSION: 'Restored Version',
  RESTORING: 'restoring....',
  RESTORING_ITEM: 'RESTORING $0',
  RESTORING_METADATA: 'restoring metadata items',
  RESULTS: 'RESULTS',
  RESULTS_LABEL: 'Results',
  RESULTS_FROM: 'Results from $0',
  RESULTS_TOOLTIP:
    'Download a CSV of verification details, including IDs that are not able to be matched with a backed up object.',
  RESTORE_CSV_DISABLED_TOOLTIP: 'Upload CSV unavailable in the backups range mode',
  RENEW_NOW: 'Renew Now',
  REQUEST_DOWNLOAD: 'Request Download ($0)',
  REQUEST_DOWNLOAD_LABEL: 'Request Download {size}',
  REQUIRED: 'Required',
  RESTORING_FROM_BACKUP: 'You are restoring from a backup on $0.',
  RESTORING_FROM_COMPARE: 'The backup was selected from a Metadata comparison on $0.',
  RESTORING_METADATA_ITEMS_TO_ORG: 'You are about to restore $0 Metadata $1 to $2.',
  RESTORING_RECORDS_TO_ORG: 'You are about to restore $0 $1 $2 to $3.',
  RESTORING_OBJECTS_TO_ORG: 'You are about to restore $0 to $1.',
  EXPORT_RECORDS: 'You are about to export $0 $1 $2.',
  RESULT: 'Result',
  RETRIEVING_BULK_RESTORE: 'retrieving records to be restored',
  RETRIEVING_METADATA: 'retrieving metadata components for comparison',
  RETRIEVING_METADATA_FOR_RESTORE: 'retrieving metadata items to be restored',
  RETRIEVING_RECORDS_TO_HANDLE: 'retrieving records to handle',
  REVIEW_ACCT: 'Please review your Account Info below and press “Next” to continue.',
  REVIEW_PAYMENT_INFO: 'Review your payment info',
  ROLES_AND_PERMISSIONS: 'Roles & permissions',
  RULE_BASED_ALERTS: 'Rule-Based Alerts',
  RUN_BY: 'Run by',
  RUN_SEARCH: 'Run Search',
  RUNNING_BACKUP_AND_EXPORT: 'BACKING UP, EXPORTING',
  RUNNING_BACKUP: 'BACKING UP',
  RUNNING_EXPORT: 'EXPORTING',
  RUNNING_BULK_RESTORE: 'RESTORING',
  RUNNING_BULK_RESTORE_CSV_VERIFICATION: 'CSV VERIFICATION',
  RUNNING_BULK_RESTORE_PREVIEW: 'DATA EXPORTING',
  RUNNING_GDPR_REQUEST: 'GDPR REQUEST HANDLING',
  RUNNING_METADATA_COMPARE: 'METADATA COMPARISON',
  RUNNING_METADATA_RESTORE: 'METADATA RESTORING',
  REVEAL_SECRET: 'Reveal Secret',
  STOPPING_TOOLTIP: '{actionName} Stopping',
  SALES_SUPPORT: 'Sales Support',
  SAVE: 'Save',
  SAVE_AS_PRESET: 'Save as Preset',
  SAVE_PRESET: 'Save Preset',
  SAVED_PRESET: 'Saved Preset',
  SAVE_PRESET_DESC: 'OK to save changes to the specified Preset? To save as a new Preset change the name below.',
  SAVE_PRESET_NEW_DESC:
    'Enter a name below to save the configured overwrite field values as a Preset for reuse in future restores.',
  SAVE_SCHEDULE: 'Save Schedule',
  SCHEDULED_BACKUP: 'Scheduled Backup',
  SCHEDULED_BACKUP_INFO: `For more information about Spanning’s automated backups, <a href="$0" target="_blank">click here</a>.`,
  SEARCH: 'Search',
  SEARCH_CRITERIA: 'Search criteria',
  SEARCH_FIELDS: 'Search Fields',
  SEARCH_OBJ: 'Search object types',
  SEARCH_OBJECT_NAME_OR_ID: 'Name or ID',
  SEARCH_OBJECT_NAME_OR_ID_TOOLTIP: 'Search will narrow down results to specific Object Name or Object ID.',
  SEARCH_TYPES: 'Search object types',
  SEARCH_PRESET: 'Search Preset',
  SEARCH_PLACEHOLDER_LOG: 'Search Log',
  SEARCH_PLACEHOLDER_BACKUP: 'Search backup',
  SEARCH_VALUES: 'Search Values',
  SEARCH_USER: 'Search user',
  SEARCHING: 'Searching...',
  SECRET: 'Secret',
  SEE_ALL_ACTIVITY: 'See All Activity',
  SEE_LESS: 'See less',
  SEE_MORE: 'See more',
  SEE_RECENT_HISTORY: 'You will be able to see all your recent history once you start backing up',
  SELECT_ALL: 'Select All',
  SELECT_A_BACKUP: 'Select a backup',
  SELECT_A_BACKUP_AND_VIEW_DETAILS: 'Select a backup below to view details',
  SELECT_CRITERIA_RUN_SEARCH: 'Define the search criteria and choose the object type',
  SELECT_CSV: 'Select CSV',
  SELECT_DATE: 'Select Date',
  SELECT_FIELD: 'Select Field',
  SELECT_FIELDS: 'Select Fields',
  SELECT_FIELD_NAME: 'select field name',
  SELECT_HOW_TO_CHOOSE_CSV: 'Select how to choose CSV',
  SELECT_ITEMS: 'select items',
  SELECT_METHOD: 'Select Method',
  SELECT_NEXT_BACKUP_TOOLTIP: 'Select the next backup',
  SELECT_OBJECT_STATE: 'Select object state',
  SELECT_OBJECT_TYPE: 'Select object type',
  SELECT_USER: 'Select User',
  SELECT_PERMISSIONS: 'Select Permissions',
  SELECT_OPERATION: 'Select operation',
  SELECT_TIME: 'Select Time',
  SELECT_TYPE: 'Select Type',
  SELECT_PRESET: 'Select a Preset',
  SELECT_PREV_BACKUP_TOOLTIP: 'Select the previous backup',
  SELECTED: ', $0 selected',
  SELECT_METADATA: 'select metadata',
  SELECT_METADATA_COMPONENTS: 'select metadata components to compare',
  SELECTED_METADATA_COUNT: '$0 metadata',
  SELECT_ORG: 'select org',
  SELECTED_RECORDS_COUNT: '$0 records',
  SELECTED_RECORDS_COUNT_ONE: '1 record',
  SELECTED_WITH_COUNT: 'selected ($0)',
  SELECTED_WITHOUT_COUNT: 'selected',
  SELECT_UPLOADED_CSV: 'Select uploaded CSV',
  SETTINGS: 'Settings',
  SETTINGS_HISTORY: 'Settings History',
  SEVERITY: 'Severity',
  SETTINGS_ACTIVITY: 'Settings Activity',
  SHORT_DAYS: '$0 d',
  SHORT_HOURS: '$0 h',
  SHORT_MINUTES: '$0 m',
  SHOW_MODIFIED_RESULTS: 'Show Modified Results Only',
  SHOW: 'Show',
  SHOW_ERRORS: 'Show {errors} Errors',
  SHOWING: 'Showing',
  SHOW_METADATA: 'Show Metadata',
  SHOW_ONLY_DIFFS: 'Only show fields with a difference',
  SHOW_ONLY_RESTORABLE_METADATA: 'Show only restorable metadata',
  SIGN_OUT: 'Log Out',
  SINGLE_ERROR: '1 Error',
  SINGLE_WARNING: '1 Warning',
  SIZE: 'Size',
  SEL_ATTACH: '$0 attachments selected',
  SELECT: 'Select',
  SELECT_EXPORT_ITEMS: 'Select Items to Export',
  SELECT_EXPORT_SETTINGS: 'Select Export Settings',
  SELECT_NEW_FIELD_VALUE: 'Select new field value',
  SELECT_NEW_FIELD_VALUES: 'Select new field values',
  SELECT_RESTORE_ITEMS: 'Select Items to Restore',
  SELECT_RESTORE_SETTINGS: 'Select Restore Settings',
  SELECT_RESTORE_VERSION: 'select version',
  SELECT_TYPE_AND_DESTINATION: 'Select Type and Destination',
  SELECT_VERSION: 'Select Version To Restore',
  SELECTED_NO_PARAMS: 'Selected',
  SKIPPED: 'Skipped',
  SORRY_FOR_DELAY: 'Sorry for The Delay',
  SORRY_NO_BACKUPS: 'Sorry, no backups from which to restore.  Backups run once daily.',
  SORT: 'Sort',
  SOURCE: 'Source',
  SOURCE_COMPONENT: 'source component',
  SPANNING_CLOUD_APPS: 'Spanning Cloud Apps',
  SPANNING_TEMPORARILY_DOWN: 'Spanning is temporarily down for planned activities.',
  SPANNING_URL: 'www.spanning.com',
  SPECIFIC_FIELDS_SUMMARY: 'You have elected to restore $0 fields.',
  SPECIFIC_FIELDS_SUMMARY_SINGULAR: 'You have elected to restore 1 field.',
  START: 'Start',
  START_PROCESS: 'Start Process',
  START_MANUAL_BACKUP_YOU_MAY: 'You may',
  START_MANUAL_BACKUP_START: 'start a manual backup',
  START_MANUAL_BACKUP_OR_WAIT: 'or wait for the next automated backup to complete.',
  START_TYPING: 'Start typing',
  STARTED: 'started',
  STATUS: 'Status',
  STATUS_SUMMARY_EMAILS: 'Status Summary Emails',
  STATUS_REPORT_DESC:
    'Choose the email address you want reports to be delivered to and how often you wish to receive them.',
  STATUS_REPORT_PREFERENCES: 'Status Report Preferences',
  STATUS_REPORTS: 'Status Reports',
  STEP_ONE: 'Step 1:',
  STEP_ONE_INSTRUCTION:
    'Create and upload a CSV file containing 18 digit Object IDs of any Object Type with column heading "id". The maximum file size allowed is 100MB.',
  SELECT_DATA_AND_DESTINATION: 'Select Data Type and Destination',
  SELECT_CSV_STEP_ONE_INSTRUCTION: 'Select previously uploaded csv file.',
  STEP_TWO: 'Step 2:',
  STEP_TWO_INSTRUCTION: 'Select the date from which to restore data then click "Verify".',
  STOPPING_MSG: '$0 Stopping',
  STOPPING_NOT_AVAILABLE: 'Stopping is not available',
  EXPORT_STEP_TWO_INSTRUCTION: 'Select the date from which to export data then click "Verify".',
  STEP_TWO_INSTRUCTION_PART_TWO:
    'Verification will run in the background to confirm that the uploaded IDs were valid as of the selected backup date.',
  SWITCH_TO_DAILY_TIME_INTERVAL: 'Switch to daily interval',
  SWITCH_TO_HOURLY_TIME_INTERVAL: 'Switch to hourly interval',
  SUBMIT: 'Submit',
  SUBMIT_SEARCH_NO_OBJECT_TYPE_TOOLTIP: 'Select an object type before running a search',
  SUBMIT_SEARCH_TOOLTIP: 'Search for backed up records matching the specified criteria',
  SUBMIT_SEARCH_UPDATE_CRITERIA_TOOLTIP: 'Change the search criteria before running another search',
  SUB_END_DATE: 'Subscription End Date',
  SUB_PERIOD: 'Subscription Period',
  SUBSCRIPTION: 'subscription',
  SUBSCRIPTION_HEADER: 'Subscription',
  SUBSCRIPTION_ENDS: 'Subscription ends',
  SUPPORT: 'Support',
  SUPPORT_TEAM: 'Support team',
  SUPPORT_EMAIL: 'KaseyaOne Portal',
  SUPPORT_PORTAL: 'KaseyaOne Portal',
  SUPPORT_USER: 'Internal User',
  SUCCESS: 'Success',
  FAILURE: 'Failure',
  SUCCESS_UPPER_CASE: 'SUCCESS',
  SUPPORT_MSG: 'For sales support, drop us a line at',
  SUPPORT_MSG_MOBILE:
    "If you have any questions or feedback, please send us an email and we'll follow up with you as soon as possible.",
  TARGET: 'Target',
  TARGET_COMPONENT: 'target component',
  TELEPHONE: 'Telephone',
  THANKS_PARTICIPATING: 'Thanks for participating!',
  THANKS_SIGNING: 'Thanks for signing up for Spanning Backup. Below is your receipt.',
  THAT_WERE_BACKED_UP_ON: 'that were backed up on',
  THAT_ARE_IN_BACKUP_OF: 'that are in backup of',
  THAT_WERE_MODIFIED_UP_ON: 'that were modified up on',
  THE_NUMBER_OF: 'The number of',
  THIS_ORG: 'This org',
  THIS_ORGANIZATION: 'This organization',
  THROUGH: 'through',
  THERE_WERE: 'There were',
  TIME_TYPE: ' $0 $1',
  TIMEOUT_REQUEST_ERROR: 'Timeout Request Error',
  TODAY: 'today',
  TODAY_TAB: 'Today',
  TOMORROW: 'tomorrow',
  TOTAL: 'total',
  TOTAL_WITHOUT_TAX: 'Total Without Sales Tax',
  TRANSACTION_DATE: 'Transaction Date',
  TRIAL: 'trial',
  TRIAL_HEADER: 'Trial',
  TRIAL_END_DATE: 'Trial End Date',
  TRIAL_ENDS: 'Trial Ends',
  TRIAL_PERIOD: 'Trial Period',
  TRIGGER: 'Trigger',
  TRIGGERS: 'Triggers',
  TYPE: 'Type',
  THRESHOLD: 'Threshold',
  UNCHANGED: 'Unchanged',
  UNDELETED: 'Undeleted',
  UNDEFINED_OBJECT: 'Undefined Object',
  UNSUPPORTED_BROWSER:
    'Sorry - this feature is not supported for Internet Explorer 9. To restore records using Object IDs, please update your browser to a more current version.',
  UPDATE: 'Update',
  UPDATED: 'Updated',
  UPDATED_OBJECTS: 'Updated Objects are restored by updating existing records',
  UPGRADE_NOW: 'Upgrade Now',
  UPGRADE_TEXT:
    'Please click Upgrade Now to purchase a yearly subscription. Or, if you would like to talk to a Sales Representative first, please contact Sales Support first.',
  UPGRADE_TO_PAID: 'Upgrade to a Active license',
  UPLOAD_OR_SELECT_AND_VERIFY_CSV: 'Upload or Select and Verify CSV',
  UPLOAD_FILE_ERROR: 'Error uploading file',
  UPLOAD_CSV: 'Upload CSV',
  UPLOAD: 'Upload',
  UPLOADING: 'Uploading',
  UPLOAD_ID_LIST: 'Upload ID list',
  UPON_COMPLETION: 'Verification will confirm that the uploaded IDs were valid as of the selected backup date.',
  USER: 'User',
  USERNAME: 'User Name',
  USER_SCHEDULE_BACKUPS_ARE: 'User scheduled backups are <span class="primary-font-med">$0</span>',
  USERS: 'Users',
  UNIT: 'Unit',
  VALUE: 'Value',
  VERIFY: 'Verify',
  PREPARE_CSV: 'Prepare CSV',
  VERIFY_FAILURE: 'Failure to verify CSV',
  VERIFYING: 'Verifying',
  VERIFYING_LIST_MASK_MSG:
    'You can choose to wait here while the verification is running, or navigate back to the Spanning Dashboard. You will be notified via email and Chatter when the verification completes.',
  VERIFYING_LIST_MASK_TITLE: 'Verifying List',
  VERIFICATION: 'Verification',
  VIEW: 'View',
  VIEW_ALL: 'View All',
  VIEW_AVG_BACKUP_DURATION: 'View Average Backup Duration',
  VIEW_DETAILS: 'VIEW DETAILS',
  VIEW_UNMATCHED_IDS: 'VIEW UNMATCHED IDS',
  VIEW_RECIEPTS: 'view reciepts',
  VIEW_BACKUP_DETAILS: 'View Backup Details',
  VIEW_METADATA_RESTORE: 'View Metadata Restore',
  VIEW_METADATA_COMPARE: 'View Metadata Compare',
  VIEW_BACKUP: 'View Backup',
  VIEW_EXPORT: 'View Export',
  WAIT_TO_START_MSG: '$0 waits to start',
  WAIT_TO_START_TOOLTIP: '{actionName} waits to start',
  WARNING: 'warning',
  WARNINGS: 'warnings',
  WARNING_MSG_SIMPLE: 'There $0 $1 and $2.',
  WEEKLY: 'Weekly',
  WELCOME: 'Welcome to Spanning Backup for Salesforce',
  WE_OFFER_METHODS: 'We offer two convenient methods of payment: Credit Card or Invoice.',
  WHOLE_OBJECTS_CHOSEN: 'The whole object$0have been chosen',
  WORKFLOWS: 'Workflows',
  WORKFLOWS_POSSIBLE_TRIGGERING:
    'During the restore process it is possible for workflows, Apex triggers, and validation rules to be triggered. We recommend disabling these before performing a restore if you encounter any errors.',
  X: 'X',
  YES: 'Yes',
  YESTERDAY_SHORT: 'Yest',
  YEAR: 'year',
  YOUR: 'Your',
  YOUR_CC: 'Your Credit Card',
  YOUR_TRIAL_EXPIRED: 'Your trial has expired',
  YOUR_SALESFORCE_ENV: 'your Salesforce environment',

  ADMINS_ONLY_CHANGED: 'Changed Only Allow Admins setting to {0}',
  ADMINS_ONLY_CHANGED_LABEL: 'Changed Only Allow Admins setting',
  API_LIMIT_CHANGED: 'Changed API limit to {0} calls',
  API_LIMIT_CHANGED_LABEL: 'Changed API limit',
  API_USED_TEMPLATE: '<strong>$0/$1</strong> calls as of $2',
  AUDIT_DATE: '<div class="sbsf-mobile-log-item-content-date">$0</div>',
  BACKUP_SCHEDULED_TEMPLATE: 'scheduled <strong> backup </strong>',
  BACKUP_MANUAL_TEMPLATE: 'manual <strong> backup </strong>',
  BACKUP_START_TIME_CHANGED: 'Backup start time changed from {oldTime} to {newTime}',
  BACKUP_START_TIME_CHANGED_LABEL: 'Backup start time changed',
  BACKUP_START_TIME_DISABLED: 'Custom Backup start time is disabled',
  BACKUP_START_TIME_SET: 'Backup start time set to {newTime}',
  BATCH_EMAIL_DETAIL: '<b>Initiated by</b>: {email}',
  BATCH_BULK_RESTORE_DETAIL_DATE:
    '<span class="sbsf-bulk-restore-chatter">$0 $1</span><div class="sbsf-chatter-export-time">$2</div><div class="sbsf-chatter-export-details">$3 of $4 records restored</div>',
  BATCH_BULK_RESTORE_DETAIL_DATE_SINGLE:
    '<span class="sbsf-bulk-restore-chatter">$0 $1</span><div class="sbsf-chatter-export-time">$2</div><div class="sbsf-chatter-export-details">1 record restored</div>',
  BATCH_BULK_RESTORE_CSV_VERIFICATION_DETAIL_DATE:
    '$0 <div class="sbsf-chatter-export-time">$1</div><div class="sbsf-chatter-export-details">$2 of $3 Object IDs were valid</div>',
  BATCH_BULK_RESTORE_CSV_VERIFICATION_DETAIL_DATE_SINGLE:
    '$0 <div class="sbsf-chatter-export-time">$1</div><div class="sbsf-chatter-export-details">$2 of 1 Object ID was valid</div>',
  BATCH_BULK_RESTORE_CSV_VERIFICATION_EXPIRES_DATE: 'Expires $0 at $1',
  BATCH_DATE_TITLE: '$0 <span class="sbsf-gray">$1</span>',
  BATCH_DETAIL_DATE:
    '<div class="sbsf-batch-info-time">$0 $1</div> <div class="sbsf-batch-info-action capitalize">$2</div>',
  BATCH_DETAIL_DATE_BULK_RESTORE:
    '<div class="sbsf-batch-info-time">$0 $1</div> <div class="sbsf-batch-info-action capitalize">$2</div><span class="sbsf-salesforce-gray primary-font-light sbsf-batch-margin-left">$3</span>',
  BATCH_DETAIL_DATE_EXPORT:
    '<div class="sbsf-batch-info-time">$0 $1</div> <div class="sbsf-batch-info-action capitalize">$2</div>$3',
  BATCH_DETAIL_DATE_METADATA_RESTORE:
    '<div class="sbsf-batch-info-time">$0 $1</div> <div class="sbsf-batch-info-action capitalize">$2</div><span class="sbsf-salesforce-gray primary-font-light sbsf-batch-margin-left">$3</span>',
  BATCH_EMAIL: '<strong>Initiated By:</strong> $0',
  BATCH_EXPORT_DETAIL_DATE:
    '$0 <div class="sbsf-chatter-export-time">$1</div><div class="sbsf-chatter-export-details">$2 Object Types - $3 Total</div>',
  BATCH_EXPORT_DETAIL_DATE_CANCELLED:
    '$0 <div class="sbsf-chatter-export-time">$1</div><div class="sbsf-chatter-export-details">Cancelled</div>',
  BATCH_METADATA_COMPARE_DETAIL_DATE:
    '<span class="sbsf-bulk-restore-chatter">$0 $1</span><div class="sbsf-chatter-export-time">$2</div><div class="sbsf-chatter-export-details">$3 items</div>',
  BATCH_METADATA_COMPARE_DETAIL_DATE_SINGLE:
    '<span class="sbsf-bulk-restore-chatter">$0 $1</span><div class="sbsf-chatter-export-time">$2</div><div class="sbsf-chatter-export-details">1 item</div>',
  BATCH_METADATA_RESTORE_DETAIL_DATE:
    '<span class="sbsf-bulk-restore-chatter">$0 $1</span><div class="sbsf-chatter-export-time">$2</div><div class="sbsf-chatter-export-details">$3 of $4 records items</div>',
  BATCH_METADATA_RESTORE_DETAIL_DATE_SINGLE:
    '<span class="sbsf-bulk-restore-chatter">$0 $1</span><div class="sbsf-chatter-export-time">$2</div><div class="sbsf-chatter-export-details">1 record item</div>',
  BATCH_MSG_TEMPLATE:
    'There $0 <span class="lower-case"><strong>$1</strong></span> and <span class="lower-case"><strong>$2</strong></span>.',
  BATCH_MSG_TEMPLATE_SHORT:
    '<span class="lower-case"><strong>$0</strong></span> and <span class="lower-case"><strong>$1</strong></span>.',
  BATCH_TTIP_TEMPLATE:
    '\'<div class="sbsf-batch-ttip"><div><strong>$0</strong> $1</div><div><strong><span class="$2">$3</span></strong> ($4 $5)</div>\'',
  BILLING_INFO_CHANGED: 'Billing information updated',
  BULK_API_LIMIT_CHANGED: 'Changed Bulk API limit to {0} calls',
  LICENSES_COUNT_CHANGED: 'Changed licenses count to {0}',
  BULK_API_LIMIT_CHANGED_LABEL: 'Changed Bulk API limit',
  LICENSES_COUNT_CHANGED_LABEL: 'Changed licenses count',
  CANCELLED_WITH_STYLE: '<span class="sbsf-cancelled-export lower-case">(Cancelled)</span>',
  CHATTER_NOTIFICATION_SETTINGS_CHANGED: 'Chatter notifications are changed',
  CHATTER_NOTIFICATION_SETTINGS_CHANGED_DISABLED: 'Chatter notifications are disabled',
  CHATTER_NOTIFICATION_SETTINGS_CHANGED_ENABLED:
    'Chatter notifications are sent to {notificationType} {notificationName}',
  CSV_VERIFIED: 'CSV Verified',
  EXPIRATION_DATE: 'Expiration Date',
  EMAIL_NOTIFICATION_SETTINGS_CHANGED: 'Email Notifications Settings are Changed',
  EMAIL_NOTIFICATION_SETTINGS_CHANGED_DISABLED: 'Email notifications are disabled',
  EMAIL_NOTIFICATION_SETTINGS_CHANGED_ENABLED: '{frequency} email notifications are sent to {address}',
  EXTERNAL_API_SECRET_DELETED: 'External API secret are deleted',
  EXTERNAL_API_SECRET_GENERATED: 'New external API secret are generated',
  EXTERNAL_API_SECRET_WARN_MESSAGE:
    'External API secret can be generated by a user logged in with Salesforce credentials.',
  INVOICE: 'You are currently setup for <strong>Invoice Billing.</strong>',
  KMS_ARN_CHANGED: 'AWS KMS key updated',
  OBJECT_RESTORE_TEMPLATE: '<strong>object restore</strong>',
  MOBILE_LOG_TEMPLATE:
    '<div class="$0"></div><div class="sbsf-mobile-log-text"><span class="sbsf-mobile-log-text-type">$1</span> <span class="lower-case">$2</span></div><div class="sbsf-mobile-log-time pull-right">$3</div>',
  NUM_DAYS_REMAINING: '$0 Days Remaining In $1',
  PRIMARY_OBJECTS_CHANGED: 'Dashboard objects updated',
  RECORD_COUNT_OBJECT: '$0 of $1 objects restored $2',
  RECORD_COUNT_OBJECT_ONE_OBJECT: '1 object restored $0',
  RENEW_SUBSCRIPTION: 'Renew Your Subscription',
  RENEWAL_TTIP:
    '<div class="sbsf-ttip"><div><strong>$0 in subscription</strong> (exp $1)</div><div>Click to Renew.</div>',
  RESTORE_VERSION_DATE: 'Restore Version <div class="sbsf-restore-confirm-date">($0)</div>',
  RESTORED_VERSION_DATE: 'Restored Version ({0})',
  SALES_REP_CONTACT: 'Please reach out to your sales representative.',
  SELECT_A_GROUP: 'Select a Group',
  SERVICE_ACCOUNT_CHANGED: 'Changed API auth account to {0}',
  SERVICE_ACCOUNT_CHANGED_LABEL: 'Changed API Auth Account',
  SORRY_EXPIRED: 'Sorry, your $0 has expired.',
  STANDARD_USERS_TTIP: 'The number of standard active users in your <br> Salesforce environment as of today.',
  SUB_EXPIRES: 'Your subscription expires on $0. You have <span class="lower-case">$1</span>.',
  SUBSCRIPTION_DATES_CHANGED: 'Changed Expiration Date to {0}',
  SUBSCRIPTION_DATES_CHANGED_LABEL: 'Changed Expiration Date',
  SUBSCRIPTION_TYPE_CHANGED: 'Changed Subscription Type to {0}',
  SUBSCRIPTION_TYPE_CHANGED_LABEL: 'Changed Subscription Type',
  SUPPORT_TEXT:
    'If you need any help with Spanning Backup, please contact support via the <a class="sbsf-link" href="https://one.kaseya.com/support" rel="noopener noreferrer" target="_blank">KaseyaOne Portal</a>. In your ticket, please include your organization ID.',
  TRIAL_EXPIRES: 'Your trial expires on $0. You have <span class="lower-case">$1</span>.',
  TRIAL_TTIP: '<div class="sbsf-ttip"><div><strong>$0 in trial</strong> (exp $1)</div><div>Click to Upgrade.</div>',
  TRY_AGAIN: 'try again',
  TWO_DIVS_TEMPLATE: '<div> $0 </div><div> $1 </div>',
  USAGE_SUCCESS_TEMPLATE: '<div class="sbsf-activity-check  sbsf-activity-check-green sca-icon-check-green"></div> $0',
  USE_KMS_CHANGED: 'Customer managed encryption key',
  USE_KMS_CHANGED_ENABLED: 'Customer managed encryption key enabled',
  USE_KMS_CHANGED_DISABLED: 'Customer managed encryption key disabled',
  USER_DATE: '<strong>$0</strong> (As of $1)',
  USERS_DATE: '{count} (as of {date})',
  USER_PERMISSIONS: 'User Permissions',
  USER_PERMISSIONS_CHANGED: 'The permissions of {0} are changed',
  USER_PERMISSIONS_CHANGED_LABEL: 'The permissions change',
  USING_KMS: 'This account has Amazon KMS configured',
  PARTIAL_MSG: 'Partial <span class="gray-text">($0% Complete)</span>',
  PARENTHESIS: '<span class="additional-text">($0)</span>',
  PARENTHESIS_TWO_ITEMS: '<span class="additional-text">($0, $1)</span>',
  PROGRESS_MSG: '<strong><span class="sbsf-dark-blue">$0</span> $1 Records</strong>',
  PROGRESS: 'Progress',
  WAS: 'was:',
  WAS_NO_COLON: 'was',
  WERE: 'were',

  '100_TITLE_ACTIVITY': 'Reached Spanning REST API Limit',
  '100_MESSAGE_ACTIVITY':
    'The daily API limit set in Spanning Backup has been reached. Processing will pause until tomorrow, when it will resume normally. Optionally, you can increase the REST API limit from the API setting on the Dashboard.',
  '101_TITLE_ACTIVITY': 'Reached Organization API Limit',
  '101_MESSAGE_ACTIVITY':
    'Spanning Backup reached the self-imposed limit of daily API calls. The backup process will resume where it left off on the following day.',
  '103_TITLE_ACTIVITY': 'Salesforce Authentication Error',
  '103_MESSAGE_ACTIVITY':
    'Spanning Backup has encountered an authentication error, please confirm that the account being used is correct and has the proper rights to access all data.',
  '104_TITLE_ACTIVITY': 'Backup Failure',
  '104_MESSAGE_ACTIVITY':
    'We encountered an error backing up your <span>{type}</span> object: <span>{message}</span> Please contact {link} for further assistance.',
  '104_MESSAGE_NO_DETAILS_ACTIVITY':
    'We encountered an error backing up your <span>{type}</span> object. Please contact {link} for further assistance.',
  '105_TITLE_ACTIVITY': 'Restore Failure',
  '105_MESSAGE_ACTIVITY':
    'We encountered an error restoring your <span>{type}</span> object: <span>{message}</span> Please contact {link} for further assistance.',
  '105_MESSAGE_NO_DETAILS_ACTIVITY':
    'We encountered an error restoring your record. Please contact {link} for further assistance.',
  '133_TITLE_ACTIVITY': 'No records found to export',
  '133_MESSAGE_ACTIVITY': 'No records were found to export from selected search criteria',
  '134_TITLE_ACTIVITY': 'Reached Spanning BULK API Limit',
  '134_MESSAGE_ACTIVITY':
    'The daily API limit set in Spanning Backup has been reached. Processing will pause until tomorrow, when it will resume normally. Optionally, you can increase the BULK API limit from the API setting on the Dashboard.',
  '139_TITLE_ACTIVITY': 'Wrong records order',
  '139_MESSAGE_ACTIVITY':
    'Received incorrect order of records from Salesforce for <span>{objectType}</span> object despite of expectation. Please contact {link} for further assistance.',
  '500_TITLE_ACTIVITY': 'An Unexpected Problem Occurred',
  '500_MESSAGE_ACTIVITY':
    'There was a problem that resulted in the <span>{type}</span> not completing, with the following error: <span>{message}</span>. Please contact {link} if the problem persists.',

  '100_TITLE': 'Reached Spanning REST API Limit',
  '100_MESSAGE':
    'The daily API limit set in Spanning Backup has been reached. Processing will pause until tomorrow, when it will resume normally. Optionally, you can increase the REST API limit from the API setting on the Dashboard.',
  '101_TITLE': 'Reached Organization API Limit',
  '101_MESSAGE':
    'Spanning Backup reached the self-imposed limit of daily API calls. The backup process will resume where it left off on the following day.',
  '103_TITLE': 'Salesforce Authentication Error',
  '103_MESSAGE':
    'Spanning Backup has encountered an authentication error, please confirm that the account being used is correct and has the proper rights to access all data.',
  '104_TITLE': 'Backup Failure',
  '104_MESSAGE':
    'We encountered an error backing up your <span class="primary-font-med">$0</span> object: <span class="primary-font-med">$1.</span> Please contact <a class="sbsf-link" target="_blank" rel="noopener noreferrer" href="https://one.kaseya.com/support">support team</a>  for further assistance.',
  '104_MESSAGE_NO_DETAILS':
    'We encountered an error backing up your <span class="primary-font-med">$0</span> object. Please contact <a class="sbsf-link" target="_blank" rel="noopener noreferrer" href="https://one.kaseya.com/support">support team</a> for further assistance.',
  '105_TITLE': 'Restore Failure',
  '105_MESSAGE':
    'We encountered an error restoring your <span class="primary-font-med">$0</span> object: <span class="primary-font-med">$1.</span> Please contact <a class="sbsf-link" target="_blank" rel="noopener noreferrer" href="https://one.kaseya.com/support">support team</a>  for further assistance.',
  '105_MESSAGE_NO_DETAILS':
    'We encountered an error restoring your record. Please contact  <a class="sbsf-link" target="_blank" rel="noopener noreferrer" href="https://one.kaseya.com/support">support team</a>  for further assistance.',
  '133_TITLE': 'No records found to export',
  '133_MESSAGE': 'No records were found to export from selected search criteria',
  '134_TITLE': 'Reached Spanning BULK API Limit',
  '134_MESSAGE':
    'The daily API limit set in Spanning Backup has been reached. Processing will pause until tomorrow, when it will resume normally. Optionally, you can increase the BULK API limit from the API setting on the Dashboard.',
  '500_TITLE': 'An Unexpected Problem Occurred',
  '500_MESSAGE':
    'There was a problem that resulted in the $0 not completing, with the following error: <span class="primary-font-med">$1.</span>  Please contact <a class="sbsf-link" target="_blank" rel="noopener noreferrer" href="https://one.kaseya.com/support">support team</a> if the problem persists.',

  TIME: 'h:mm a',
  DAY: 'ddd',
  DOW_M_D_Y: 'ddd, MMM D[,] YYYY',
  H_M: 'h:mm A',
  M_D: 'MMM D',
  M_D_Y: 'MMM D[,] YYYY',
  M_D_Y_FULL: 'MMMM D[,] YYYY',
  M_D_Y_H_M: 'MMM D[,] YYYY h:mm A',
  MDY: 'M/D/YY',
  MDY_H_M_12HR: 'l - h:mm a',
  MED_TZ: 'MMM D[,] YYYY H:mm:ss ZZ',
  L_H_M_12HR: 'l, h:mm a',

  DELETED_ITEMS_PREVIEW_DESCENDANTS_FAILED: 'There was a problem retrieving descendants. Please try again.',
  DELETED_ITEMS_PREVIEW_FAILED: 'There was a problem retrieving the preview data. Please try again.',
  DELETED_ITEMS_RECORDS_FAILED: 'There was a problem retrieving the deleted items. Please try again.',
  DELETE_PAYMENT_INFO_FAILED: 'There was a problem deleting your Credit Card information. Please try again.',
  ERROR_ADDING_ORG: 'There was an error adding the org.',
  ERROR_OCCURRED: 'An Error has occurred. Please contact support via the KaseyaOne Portal if the problem persists.',
  ERROR_UPDATING_FORM: 'There was invalid data in the form.',
  ERROR_UPDATING_PAYMENT: 'There was an error updating your payment info.',
  ERROR_UPDATING_SETTING: 'There was an error updating your setting.',
  GET_AUDIT_EVENTS_FAILED: 'Unable to load audit history.',
  INVALID_REFRESH_TOKEN_ERROR:
    'The Salesforce API User account is currently disabled, or inactive. Please ensure the API user still exists in Salesforce, has a valid license and valid permissions.',
  LOAD_API_DATA_COUNT: 'Unable to load API count data.',
  LOAD_API_USAGE_FAILED: 'Unable to load API usage history.',
  LOAD_BACKUP_USER_FAILED: 'Unable to load user.',
  LOAD_BATCH_DATA_FAILED: 'Unable to load backup details.',
  LOAD_LOG_DATA_FAILED: 'Unable to load activity history.',
  LOAD_ORG_DATA_FAILED: 'Unable to load org info.',
  LOGOUT: 'Log Out',
  PAYMENT_TRANSACTION_FAILED: 'Payment transaction failed. Please try again.',
  PAYMENT_UPDATE_FAILED: 'There was a problem updating your Credit Card information. Please try again.',
  REQUEST_INVOICE_FAILED: 'There was a problem requesting an invoice. Please try again.',
  SEARCH_ITEMS_RECORDS_FAILED: 'There was a problem retrieving the items. Please try again.',
  SUBMIT_BACKUP_FAILED: 'Your backup was unable to start. Please try again.',
  SUBMIT_EXPORT_FAILED: 'Your export was unable to start. Please try again.',
  SUBMIT_BULK_RESTORE_PREVIEW_FAILED: 'Your export was unable to start. Please try again.',

  CARD_ADDED_SUCCESSFULLY: 'Card added successfully.',
  CARD_REMOVED_SUCCESSFULLY: 'Card removed successfully.',
  EXPORT_COMPLETE: 'Export completed.',
  MANUAL_BACKUP_COMPLETE: 'Manual Backup completed.',
  UPGRADE_COMPLETE: 'Purchase completed. Thanks for choosing Spanning Backup for Salesforce!',
  INVALID_CONFIG: 'Access Error',
  INVALID_CONFIG_MESG:
    'You cannot access Spanning Backup in this manner. Please contact your Salesforce admin to ensure that Spanning Backup is properly configured.',
  INVALID_CONFIG_RESTORE: 'Whoa Pardner',
  INVALID_CONFIG_MESG_RESTORE:
    'You\'ve navigated directly to the Spanning Restore tab, which should be hidden.  Restore is initiated by pressing a restore button on a Salesforce record.  Please see the <a target="_top" href="http://spanning_static.s3.amazonaws.com/installation.pdf">Installation guide</a> for more information.',

  SPANNING_REST_API_LIMIT: 'Over the Spanning REST API limit',
  SPANNING_REST_API_LIMIT_DESC: 'The user imposed REST API limit has been reached.',
  SPANNING_BULK_API_LIMIT: 'Over the Spanning BULK API limit',
  SPANNING_BULK_API_LIMIT_DESC: 'The user imposed BULK API limit has been reached.',
  SALESFORCE_REST_API_LIMIT: 'Over the Salesforce REST API limit',
  SALESFORCE_REST_API_LIMIT_DESC: 'The salesforce REST API limit has been reached',
  SALESFORCE_BULK_API_LIMIT: 'Over the Salesforce BULK API limit',
  SALESFORCE_BULK_API_LIMIT_DESC: 'The salesforce BULK API limit has been reached',
  IMPLEMENTATION_RESTRICTION: 'Object cannot be queried',
  IMPLEMENTATION_RESTRICTION_DESC:
    'We were unable to query for this object due to restrictions imposed by the Salesforce API.',
  SALESFORCE_AUTHENTICATION_ERROR: 'Salesforce authentication error',
  SALESFORCE_AUTHENTICATION_ERROR_DESC: 'An error occurred when attempting to authenticate with Salesforce.',
  OBJECT_BACKUP_FAILURE: 'Unable to backup object',
  OBJECT_BACKUP_FAILURE_DESC: 'The object was unable to be backed up.',
  OBJECT_EXPORT_CONFIRMATION: 'You are about to perform an export. Click ‘Confirm’ to begin the export process.',
  OBJECT_RESTORE_CONFIRMATION:
    'You are about to perform an Object restore. This process cannot be undone. Click ‘Confirm’ to begin the restore process.',
  OBJECT_RESTORE_ERROR: 'Unable to restore object',
  OBJECT_RESTORE_ERROR_DESC: 'The object was unable to be restored',
  SALESFORCE_OBJECT_CREATE_ERROR: 'Record creation failed',
  SALESFORCE_OBJECT_CREATE_ERROR_DESC: 'We were unable to create the record in salesforce.',
  SALESFORCE_INSUFFICIENT_ACCESS: 'Insufficient Salesforce Access',
  SALESFORCE_INSUFFICIENT_ACCESS_DESC: 'The user performing the operation does not have sufficient permissions',
  SALESFORCE_INACTIVE_USER: 'Inactive Salesforce user',
  SALESFORCE_INACTIVE_USER_DESC:
    'The user performing (or assigned to) this action is inactive in Salesforce.  Please reactivate or change the user.',
  BATCH_OUTPUT_DOWNLOADED: 'Export data downloaded',
  BATCH_OUTPUT_DOWNLOADED_DESC:
    'The specified user requested to download a finished export from Spanning Backup for Salesforce.',
  AWS_KMS_ERROR: 'AWS encryption key error',
  AWS_KMS_ERROR_DESC: 'The currently defined AWS encryption key is either invalid or inactive.',
  INSUFFICIENT_ACCESS_CROSS_REF: 'Insufficient permissions to referenced id',
  INSUFFICIENT_ACCESS_CROSS_REF_DESC:
    'The user performing the operation does not have sufficient permissions to access a referenced id',
  OUT_OF: 'out of',
  OUT_OF_STORAGE_SPACE: 'Storage quota exceeded',
  OUT_OF_STORAGE_SPACE_DESC: 'The Salesforce storage quota has been reached.',
  ENTITY_LOCKED: 'Record is locked',
  ENTITY_LOCKED_DESC:
    'Constraints defined in Salesforce have caused this record to be locked. The record cannot be updated until the relevant field causing the lock is changed to a different value.',
  UNCREATABLE_FIELD: 'Field cannot be created',
  UNCREATABLE_FIELD_DESC: 'The current Salesforce API does not allow third-party vendors to create this field.',
  UNUPDATABLE_FIELD: 'Field cannot be updated',
  UNUPDATABLE_FIELD_DESC: 'The current Salesforce API does not allow third-party vendors to update this field.',
  REQUIRED_FIELD_MISSING: 'Required field missing',
  REQUIRED_FIELD_MISSING_DESC:
    'A required field is not defined, which prevents the current operation from completing successfully.',
  INACTIVE_RECORD_REFERENCE: 'Inactive Record Reference',
  INACTIVE_RECORD_REFERENCE_DESC: 'A referenced id is inactive and cannot be accessed. Please activate the record.',
  INTERNAL_ERROR: 'Internal Error',
  INTERNAL_ERROR_DESC: 'An internal error has occurred.  Please contact Spanning Support.',
  OPERATION_TIMED_OUT: 'Operation Timed Out',
  OPERATION_TIMED_OUT_DESC: 'Salesforce did not respond in a timely fashion.',
  AUTH_INFO_NOT_FOUND: 'Authorization info not found',
  AUTH_INFO_NOT_FOUND_DESC: 'The operation could not be authorized.',
  DATABASE_CONNECTIVITY_ERROR: 'Database connection error',
  DATABASE_CONNECTIVITY_ERROR_DESC: 'The database could not be reached.',
  SALESFORCE_LAYOUT_NOT_FOUND: 'Layout not found',
  SALESFORCE_LAYOUT_NOT_FOUND_DESC: 'This item depends on a layout that was not selected to be restored.',
  SALESFORCE_PARENT_NOT_FOUND: 'Parent not found',
  SALESFORCE_PARENT_NOT_FOUND_DESC: 'This item depends on a parent item that was not selected to be restored.',
  SALESFORCE_CANNOT_CREATE_WORKFLOW: 'Cannot create workflow',
  SALESFORCE_CANNOT_CREATE_WORKFLOW_DESC: 'The workflow could not be restored.',
  SALESFORCE_MISSING_META_XML_FILE: 'Missing metadata file',
  SALESFORCE_MISSING_META_XML_FILE_DESC:
    'This item was deployed without its corresponding -meta.xml file being selected.',
  SALESFORCE_DASHBOARD_GRID_LAYOUT: 'Dashboard grid to three column change',
  SALESFORCE_DASHBOARD_GRID_LAYOUT_DESC: 'You cannot change dashboard from new grid layout to old three columns',
  SALESFORCE_METADATA_DEPLOYMENT_ROLLBACK: 'Metadata component deployment rolled back',
  SALESFORCE_METADATA_DEPLOYMENT_ROLLBACK_DESC:
    'This metadata component deployment was rolled back because of a different error during deployment',
  SALESFORCE_IN_FIELD_VALIDATION: 'Salesforce In Field Validation Error',
  SALESFORCE_IN_FIELD_VALIDATION_DESC: 'An error occurred when Salesforce attempted to validate a field',
  SALESFORCE_EDIT_INVALID_TAB: 'Salesforce deploy error',
  SALESFORCE_EDIT_INVALID_TAB_DESC: 'An error occurred when Salesforce attempted to edit tab settings for invalid tab',
  SALESFORCE_WRONG_NAMESPACE: 'Salesforce deploy error',
  SALESFORCE_WRONG_NAMESPACE_DESC:
    'An error occurred when Salesforce attempted to create component because the namespace of the component does not match the organization namespace',
  BULK_RESTORE_CANCELLED: 'Bulk Restore cancelled',
  BULK_RESTORE_CANCELLED_DESC: 'The Bulk Restore has been cancelled.',

  AUTOMATION_DISABLE_ERROR: 'Automation Disable Error',
  AUTOMATION_DISABLE_ERROR_DESC:
    'An unexpected error occurred when disabling automations for your organization. Please contact support.',
  AUTOMATION_ENABLE_ERROR: 'Automation Enable Error',
  AUTOMATION_ENABLE_ERROR_DESC:
    'An unexpected error occurred when enabling automations for your organization. Some automations may remain disabled. Use the "Enable automation back" button to manually enable them again. Please contact support.',
  ADDRESS_ONE: 'Address 1',
  ADDRESS_TWO: 'Address 2 (optional)',
  BUSINESS_ADDRESS: 'Business address',
  CHECK_ADDRESS: 'Check address',
  NO_BUSINESS_ADDRESS: 'No business address',
  CITY: 'City',
  COUNTRY: 'Country',
  ZIP: 'ZIP / Postal Code',
  STATE: 'State / Region',
  STATE_NAME: 'State',

  TAX_ADDRESS_ONE_DEFAULT_TOOLTIP: 'Please enter your business address line 1',
  TAX_CITY_DEFAULT_TOOLTIP: 'Please enter your business address city',
  TAX_COUNTRY_DEFAULT_TOOLTIP: 'Please enter your business address country',
  TAX_ZIP_DEFAULT_TOOLTIP: 'Please enter your business address postal code',
  TAX_STATE_DEFAULT_TOOLTIP: 'Please enter your business address state',

  SALES_TAX: 'Estimated Sales Tax',
  SALES_TAX_TOOLTIP: 'Estimated tax for your business address and final price per user',

  PAYMENT_DETAILS_CHANGED_TITLE: 'Payment information has been updated',
  PAYMENT_DETAILS_CHANGED_MSG:
    'Your payment information has been updated since the last transaction. Please ensure the information is accurate to ensure a timely charge in the future.',
  REVIEW_CHANGED_COST: 'Review Payment Information',
  COST_BASEMENT: '* - Cost is based on your previous purchases and may differ from actual',

  RESTORE_RELATED_OBJECT_TYPES: 'Related Object Types',
  RESTORE_RELATED_OBJECT_TYPES_DESCRIPTION:
    'Below is a list of related object types for the items chosen to restore. Your restore may run into errors if the related records do not exist in the Salesforce org.',

  RESTORE_OBJ_SAME_ORG_ITEM_1:
    'You can search across backups for deleted and updated records, or you can {csvLink} of object IDs',
  RESTORE_UPLOAD_A_CSV_LIST: 'upload a CSV list',
  RESTORE_OBJ_SAME_ORG_ITEM_2: 'Permanently deleted Objects are restored as new records with new IDs',
  RESTORE_OBJ_SAME_ORG_ITEM_3:
    'Deleted Objects in the Recycle Bin are restored with same IDs, restoring all dependencies and maintaining IDs, regardless of selecting Classic or Granular Restore in Spanning',
  RESTORE_OBJ_SAME_ORG_ITEM_4: 'Updated Objects are restored by updating existing records',
  RESTORE_OBJ_SAME_ORG_ITEM_5:
    'You will have the option to include child (detail) records when restoring deleted records',
  RESTORE_OBJ_SAME_ORG_ITEM_6:
    'During the restore process it is possible for workflows, Apex triggers, and validation rules to be triggered. We recommend disabling these before performing a restore if you encounter any errors',
  RESTORE_OBJ_SAME_ORG_ITEM_7:
    'You will have the option to export your Objects for review before completing the restore',

  RESTORE_OBJ_CROSS_ORG_ITEM_1:
    'Ensure that the destination org is setup with the same customizations and metadata as the source org',
  RESTORE_OBJ_CROSS_ORG_ITEM_2:
    'Ensure the destination org will have enough storage space to accommodate the data you select from the source org',
  RESTORE_OBJ_CROSS_ORG_ITEM_3:
    'Confirm that you are authenticated and have "Modify All Data" permission for the destination org',

  RESTORE_METADATA_SAME_ORG_ITEM_1:
    'Use this feature to restore metadata from a previous point-in-time backup back into this org',
  RESTORE_METADATA_SAME_ORG_ITEM_2:
    'In the next step, you will have the option to select which metadata items you would like to restore',
  RESTORE_METADATA_SAME_ORG_ITEM_3:
    'You will be able to confirm your selections before starting the restoration of the metadata items',
  RESTORE_METADATA_SAME_ORG_ITEM_4:
    'Once the restore is complete, you will be notified via email and Chatter (if enabled)',

  RESTORE_METADATA_CROSS_ORG_ITEM_1:
    'Use this feature to restore metadata from a previous point-in-time backup back into a different org, even if Spanning is not installed in the different org)',
  RESTORE_METADATA_CROSS_ORG_ITEM_2:
    'Authorize using your credentials for any production org, developer org, or sandbox',
  RESTORE_METADATA_CROSS_ORG_ITEM_3:
    'In the next step, you will have the option to select which metadata items you would like to restore',
  RESTORE_METADATA_CROSS_ORG_ITEM_4:
    'You will be able to confirm your selections before starting the restoration of the metadata items',
  RESTORE_METADATA_CROSS_ORG_ITEM_5:
    'Once the restore is complete, you will be notified via email and Chatter (if enabled)',

  RESTORE_MORE_INFORMATION: 'For more information, click here',

  RESTORE_SETTINGS_SELECT_RESTORE_SETTINGS: 'Select Restore Settings',
  RESTORE_SETTINGS_INCLUDE_CHILDREN_OF_RECORDS_TITLE: 'Include children of records',
  RESTORE_SETTINGS_INCLUDE_CHILDREN_OF_RECORDS_DESC:
    'When restoring records, also restore related children and grandchildren',
  RESTORE_SETTINGS_RESTORE_SPECIFIC_FIELDS_OF_RECORDS_TITLE: 'Restore specific fields of records',
  RESTORE_SETTINGS_RESTORE_SPECIFIC_FIELDS_OF_RECORDS_DESC:
    'Select specific fields to restore for records if the data loss is limited to a few fields',
  RESTORE_SETTINGS_OVERWRITE_FIELD_VALUES_TITLE: 'Overwrite field values during the restore process',
  RESTORE_SETTINGS_OVERWRITE_FIELD_VALUES_DESC:
    'Replace field values for specific fields of Object Types during the restore process',
  RESTORE_SETTINGS_RESTORE_LOOKUP_RELATIONSHIPS_TITLE: 'Restore Lookup Relationships',
  RESTORE_SETTINGS_RESTORE_LOOKUP_RELATIONSHIPS_DESC: 'Restore other records that referenced to selected record',
  RESTORE_SETTINGS_REPAIR_LOOKUP_RELATIONSHIPS_TITLE: 'Repair Lookup Relationships',
  RESTORE_SETTINGS_REPAIR_LOOKUP_RELATIONSHIPS_DESC:
    'Repair lookup relationships of other records that referenced to selected record',
  RESTORE_SETTINGS_DISABLE_APEX_TRIGGERS_TITLE: 'Disable Apex triggers, flows and workflows',
  RESTORE_SETTINGS_DISABLE_APEX_TRIGGERS_DESC:
    'All Apex triggers, flows and workflows will be enabled after restore session',
  RESTORE_SETTINGS_IGNORE_WARNINGS_TITLE: 'Ignore Warnings',
  RESTORE_SETTINGS_IGNORE_WARNINGS_DESC:
    'Spanning backup will ignore warnings from Salesforce during this metadata restore only.',
  RESTORE_SETTINGS_OBJECT_TYPE: 'Object type',
  RESTORE_SETTINGS_OVERWRITE_WITH: 'Overwrite with',
  RESTORE_SETTINGS_VALUE: 'Value',
  RESTORE_SETTINGS_ADD_SPECIFIC_FIELDS: 'Add Specific Fields',
  RESTORE_SETTINGS_ADD_OVERWRITE_RULE: 'Add Overwrite Rule',
  RESTORE_SETTINGS_SAVE_AS_PRESET: 'Save as Preset',
  RESTORE_SETTINGS_LOAD_A_PRESET: 'Load a Preset',
  RESTORE_SETTINGS_SAVE_OVERWRITE_TEMPLATE:
    'Enter a name below to save the configured overwrite field values as a Preset for reuse in future restores.',
  RESTORE_SETTINGS_DELETE_OVERWRITE_TEMPLATE: 'You are about to delete preset "{preset}". Confirm?',
  RESTORE_SETTINGS_WARNING: 'Warning!',
  RESTORE_SETTINGS_NO_REQUIRED_OBJECT_FIELDS: 'There are no required Object fields in chosen template.',
  RESTORE_SETTINGS_ERROR_CREATING_OVERWRITE_TEMPLATE: 'Error creating overwrite template.',
  RESTORE_SETTINGS_OVERWRITE_TEMPLATE_ALREADY_EXISTS: 'Template with such name and fields already exists.',

  SELECT_ITEMS_TABLE_COUNTS:
    '{objectsCount, plural, =1 {# Object} other {# Objects}}, {recordsCount, plural, =1 {# Record} other {# Records}} selected',

  CONFIRM_RESTORE_OBJECTS_RECORDS_COUNT_SAME_ORG:
    '{objectsCount, plural, =1 {# Object} other {# Objects}}, {recordsCount, plural, =1 {# Record} other {# Records}} are about to be restored to this organization.',
  CONFIRM_RESTORE_OBJECTS_ITEMS_COUNT_CROSS_ORG:
    '{objectsCount, plural, =1 {# Object} other {# Objects}}, {recordsCount, plural, =1 {# Record} other {# Records}} are about to be restored to {name} ({sfId}).',
  CONFIRM_RESTORE_SPECIFIC_FIELDS_COUNT:
    'You have selected to restore {specificFieldsCount, plural, =1 {# field} other {# fields}}.',
  CONFIRM_RESTORE_OVERWRITE_FIELDS_COUNT:
    'You have selected to overwrite {overwriteFieldsCount, plural, =1 {# field} other {# fields}}.',
  CONFIRM_RESTORE_OBJECT_SUMMARY_DESCRIPTION:
    'Please review the items below to ensure that you are restoring the correct objects and records before starting the restoration process.',

  CONFIRM_RESTORE_METADATA_TYPES_COUNT: '{typesToRestoreCount, plural, =1 {# Metadata type} other {# Metadata types}}',
  CONFIRM_RESTORE_METADATA_ITEMS_COUNT_SAME_ORG:
    '{itemsToRestoreCount, plural, =1 {# Metadata item is} other {# Metadata items are}} about to be restored to this organization.',
  CONFIRM_RESTORE_METADATA_ITEMS_COUNT_CROSS_ORG:
    '{itemsToRestoreCount} Metadata items are about to be restored to {name} ({sfId}).',
  CONFIRM_RESTORE_METADATA_IGNORE_WARNINGS:
    'Spanning will ignore warnings from Salesforce during this metadata restore operation only.',
  CONFIRM_RESTORE_METADATA_SUMMARY_DESCRIPTION:
    'Please review the items below to ensure that you are restoring the correct metadata items before starting the restoration process.',
  CONFIRM_RESTORE_METADATA_RESTORING_FROM_BACKUP: 'You are restoring from a backup on {backupDate}.',

  RETENTION: 'retention',
  CONFIGURABLE_RETENTION_POLICY: 'Configurable Retention Policy',
  CONFIGURABLE_RETENTION_POLICY_DESC:
    'Configurable Retention Policy empowers to control the duration of data retention, enabling flexible policies tailored to various criteria. This feature enhances data management in Spanning Salesforce backup, optimizing storage and ensuring compliance.',

  ENABLE_CONFIGURABLE_RETENTION_POLICY: 'Enable Configurable Retention Policy',
  ORGANIZATION_DEFAULT_POLICY: 'Organization Default Policy',
  ORGANIZATION_DEFAULT_POLICY_DESC:
    'Set a global retention policy for consistent data management across your organization.',
  ORGANIZATION_DEFAULT_POLICY_CONSTRAINT:
    'When choosing Retention by Modified Date, please note that this applies only to object types. Metadata will always follow the Backup Date retention policy because the modification date for metadata is not available.\n' +
    '\n' +
    'Ensure this aligns with your data retention needs before proceeding.\n',
  RETENTION_PERIOD: 'Retention Period',
  RETENTION_BASED_ON: 'Retention Based on',
  RETENTION_TYPE: 'Retention Type',
  ITEM_POLICY: 'Item Policy',
  ITEM_POLICY_DESC:
    'Customize retention for specific items. Item policies override the global default, offering more granular control.',
  ITEM_NAME: 'Item Name',
  SELECT_ITEM: 'Select Item',
  SELECT_ITEM_NAME: 'Select Item Name',
  SELECT_PERIOD: 'Select Period',
  SELECT_RETENTION_TYPE: 'Select Retention Type',
  ADD_ITEM: 'Add Item',
  RESTORE_BACKUP_DATE_OPTION_DESC: 'Keep data based on when the backup was performed',
  MODIFIED_DATE: 'Modified date',
  RESTORE_MODIFIED_DATE_OPTION_DESC: 'Keep data based on when the file or record was modified or created',
  RETENTION_FEATURE_UPDATED_SUCCESSFULLY: 'Retention feature updated successfully.',
  RETENTION_RULE_ADDED_SUCCESSFULLY: 'Retention rule added successfully.',
  RETENTION_RULE_UPDATED_SUCCESSFULLY: 'Retention rule updated successfully.',
  RETENTION_RULE_DELETED_SUCCESSFULLY: 'Retention rule deleted successfully.',
  RETENTION_RULE_DELETE_TITLE: 'Delete item policy',
  RETENTION_RULE_DELETE_MSG: 'Are you sure you want to delete selected item policy?',

  RESTORE_NEW: 'Restore New'
};
